<template>
<div style="">
<div v-if="isLoading" class="loading">Loading&#8230;</div> 

<div id="myModalFilesPending" class="modal">
  <div class="modal-background" @click="modal_close_files()"></div>
  <div class="modal-content" style="width: 55%;height: 80%">
    <div  class="box">


<div class="columns is-gapless">

    <div class="column is-4">
        <a @click="modal_show_files()" class="button is-fullwidth  has-background-grey-dark has-text-white"><i class="fas fa-history"></i>&nbsp;&nbsp;HISTORY</a> 
    </div>

    <div class="column is-4"></div>
    <div class="column is-4">
        <a @click="modal_show_files()" class="button is-fullwidth  has-background-grey-dark has-text-white">CHECK FOR FILES</a> 
    </div>
    
</div>


<div class="columns">
    <div class="column is-5"></div>
    <div class="column is-1">CON.</div>
    <div class="column is-1">DET.</div>
</div>
<!-- {{data.fileConfirm}} -->

        <div class="columns is-multiline has-text-centered colBorderBottom" v-for="(data,index) in data_files_pending" :key="index">

<div class="column is-5">
<div class="columns is-multiline">
    <div class="column is-2">{{data.fileTran_FILE}}</div>
    <div class="column is-5">{{data.fileTran_DATE | moment("add", "1 days","MMM-DD-YY")}} <span class="is-size-7"> {{data.fileTran_DATE | moment("HH:mm")}} </span> </div>
    <div class="column is-5">{{data.fileTran_SESS}}-{{data.fileTran_ANN}} :: {{data.fileTran_TYPE}}</div>    
    <div class="column is-12 has-text-left" style="margin-top:-1.8em;">{{data.fileTran_COMMENTS}}</div>
</div>
</div>



 <!-- v-if='check_file_confirm(index)' -->
            <div class="column is-1 has-text-centered">{{data.fileConfirm}} </div>
                <!-- <i class="fas fa-check-square fa-2x"></i> -->
            <!-- <div v-else class="column is-1 has-text-centered">{{data.fileConfirm}} <i class="far fa-clock fa-2x"></i></div> -->

                <!-- <span v-if="data.fileConfirm=='1'" class=""><i class="fas fa-check-square fa-2x"></i></span>
                <span v-else class=""><i class="far fa-clock fa-2x"></i></span> -->
           
            <div class="column is-1">{{data.fileDetail}}
                <!-- <span v-if="data.fileDetail==1" class=""><i class="fas fa-check-square fa-2x"></i></span>
                <span v-else class=""><i class="far fa-clock fa-2x"></i></span>                 -->
            </div>
            <div class="column is-1"></div>

<div v-if="(data.fileConfirm==true || data.fileDetail==true)"  class="column is-4">
    <a @click="process_file(index, data.fileTran_ID,data.fileFTP_CON,data.fileFTP_DET)" class="button is-fullwidth  has-background-success">PROCESS</a> 
</div>

<div v-if="data.fileShow==1" class="column is-12">




<div class="columns is-multiline">
    <div class="column is-4">{{file_message_1}}</div>
    <div class="column is-4">{{file_message_2}}</div>
    <div @click="print_errors()" v-if="errorCount>0" class="column is-4 underIT isLink">PRINT</div>
    <div class="column is-12" v-for="(data,index) in data_students_file" :key="index">
        <div v-if="data.error!=''" class="columns">
            <div class="column is-4">{{data.student_lNAME}}, {{data.student_fNAME}}</div>
            <div class="column is-8 colNotes">{{data.error}}</div>
        </div>
    </div>
</div></div>



        </div> 
        <!-- END LOOP {{data_files_pending}} -->
        
    </div>
 </div>
</div>

<div id="myModalTransmission" class="modal">
  <div class="modal-background" @click="modal_close()"></div>
  <div class="modal-content" style="width: 45%">
    <div  class="box">

<div class="columns has-text-weight-bold is-gapless is-multiline colBorder" style="margin-bottom:0em;padding:.5em;">
<div class="column is-2 colBorderRight has-background-grey-dark has-text-light">TYPE</div>
<div class="column is-2 colBorderRight has-text-centered has-background-success-light">CREATE</div>
<div class="column is-2 colBorderRight has-text-centered has-background-warning-light">MODIFY</div>
<div class="column is-2 has-text-centered has-background-danger-light colBorderRight">CANCEL</div>
<div class="column is-4 has-text-right">NOTE&nbsp;&nbsp;</div>
</div>




<div class="columns has-text-weight-bold is-gapless is-multiline colBorder" style="margin-bottom:0em;padding:.5em;" v-for="(data,index) in data_confirm" :key="index">
<div class="column is-2 colBorderRight">&nbsp;&nbsp;{{data.tran_type}}</div>
<div class="column is-2 colBorderRight has-text-centered">
   <span v-if="data.tran_c > 0" class="has-background-success-light"> &nbsp;&nbsp;&nbsp;&nbsp;{{data.tran_c}} &nbsp;&nbsp;&nbsp;&nbsp; </span>
</div>
<div class="column is-2 colBorderRight has-text-centered">
    <span v-if="data.tran_m > 0" class="has-background-warning-light"> &nbsp;&nbsp;&nbsp;&nbsp;{{data.tran_m}} &nbsp;&nbsp;&nbsp;&nbsp; </span>
</div>
<div class="column is-2 has-text-centered colBorderRight">
    <span v-if="data.tran_a > 0" class="has-background-danger"> &nbsp;&nbsp;&nbsp;&nbsp;{{data.tran_a}} &nbsp;&nbsp;&nbsp;&nbsp; </span>
</div>
<div class="column is-4"><input  v-model="data.note" class="input is-fullwidth" type="text" placeholder="...."></div>



</div>

<div class="columns is-gapless">
  <div class="column is-3 has-text-centered"> 
    <a @click="modal_cancel_tran()" class="button is-fullwidth  has-background-grey-dark has-text-white has-tooltip-left has-tooltip-danger" data-tooltip="Déconnexion">
      &nbsp;&nbsp;<span class="icon"><i class="fas fa-sign-out-alt"></i></span>&nbsp;&nbsp;CANCEL !</a> 
  </div>
  <div class="column is-4"></div>

  <div class="column is-2 has-text-centered"> 
    <a @click="modal_close()" class="button is-fullwidth  has-background-grey-dark has-text-white has-tooltip-left has-tooltip-danger" data-tooltip="Déconnexion">
      &nbsp;&nbsp;<span class="icon"><i class="fas fa-sign-out-alt"></i></span>&nbsp;&nbsp;CLOSE</a> 
  </div>
  <div class="column is-3 has-text-centered"> 
    <a @click="create_files()" class="button is-fullwidth  has-background-grey-dark has-text-white has-tooltip-left has-tooltip-danger" data-tooltip="Déconnexion">
      &nbsp;&nbsp;<span class="icon"><i class="fas fa-sign-out-alt"></i></span>&nbsp;&nbsp;SEND </a> 
  </div>
</div>




    </div>
  </div>
</div>
<!-- ----------- END MODAL ! --------------  -->





<!-- HEADER -- SEND/RECU BUTTONS! -->
<div class="columns is-gapless has-background-grey-dark" style="padding-top:1em;">


    <div class="column is-1">
        <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-angle-double-right"></i></span>     
        </button> 
    </div>

    <div class="column is-2 has-text-right has-background-grey-dark has-text-grey-lighter has-text-weight-bold is-size-5">
        &nbsp;&nbsp;&nbsp;&nbsp;
    </div>

<div class="column is-3 is-pulled-right has-background-grey-dark has-text-grey-lighter has-text-weight-bold">
        <span style="background-color:#23d160">&nbsp;&nbsp;&nbsp;DONE&nbsp;&nbsp;&nbsp;</span>
        <span style="background-color:#209cee">&nbsp;&nbsp;&nbsp;TO DO&nbsp;&nbsp;&nbsp;</span>
        <span style="background-color:#ff3860">&nbsp;&nbsp;&nbsp;ERROR&nbsp;&nbsp;&nbsp;</span>
        <span style="background-color:#ffdd57;color:black;">&nbsp;&nbsp;&nbsp;PENDING&nbsp;&nbsp;&nbsp;</span>
</div>



    <div class="column is-4  has-text-right has-text-weight-bold">
<div class="columns">
    <div class="column is-12 has-text-light" style="margin-top:.8em;">
    
    <span class="has-text-success"> CREATE </span>&nbsp;: {{cnt_add}} 
&nbsp;&nbsp;&nbsp;&nbsp;
     <span class="has-text-warning">MODIFY</span>&nbsp;: {{cnt_mod}} 
&nbsp;&nbsp;&nbsp;&nbsp;
    <span class="has-text-danger"> CANCEL</span>&nbsp;: {{cnt_del}} 
&nbsp;&nbsp;&nbsp;&nbsp;           
    </div>
</div>

 
</div>

<div class="column is-2  has-text-centered has-text-weight-bold">
<div class="columns">

<div style="margin-top:.6em;" class="column is-6 has-text-centered has-text-weight-bold"><a @click="create_files_confirm()" class="button is-small is-fullwidth has-background-light has-text-dark has-badge-rounded has-badge-success has-badge-large" :data-badge="data_toTransmit.length"><span class="icon is-large"><i class="fas fa-file-export"></i></span>&nbsp;&nbsp;&nbsp;SEND</a></div>
<div style="margin-top:.6em;margin-left:-1em;" class="column is-6 has-text-centered has-text-weight-bold">
    <a @click="modal_show_files()" class="button is-small is-fullwidth has-background-light has-text-dark has-badge-rounded has-badge-info has-badge-large" :data-badge="cnt_files_pending"><span class="icon is-large"><i class="fas fa-file-import"></i></span>&nbsp;&nbsp;&nbsp;RECU
    </a></div>        
    
</div>
</div>
</div>
<!-- END HEADER -- SEND/RECU BUTTONS! test_encrypt -->


<!-- SIDEBAR !!!!  -->
<div id="mySidebar" class="sidebar" style="margin-top:3.7em;">

<div class="box is-radiusless has-background-grey-dark" style="margin-bottom:0em;">
<div class="columns is-multiline is-gapless">

    <div class="column is-10 is-size-6 has-text-grey-lighter">
       Transmission
    </div>

    <div class="column is-2">
        <button @click="sortNav()" class="button is-fullwidth has-background-dark has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-angle-double-left"></i></span>     
        </button> 
    </div>


<div v-if="+show_change_session" class="column is-12" style="">
<div class="columns is-multiline is-gapless">

    <div class="column margeBottomMore is-3 control">
    <div class="select is-fullwidth">
        <select v-model="grp_sess">
            <option value="H">H</option> <option value="E">E</option>  <option value="A">A</option>
        </select>
    </div></div>

    <div class="column margeBottomMore is-4 control ">
    <div class="select is-fullwidth">
        <select v-model="grp_ann">
            <option>17</option><option>18</option><option>19</option> <option value="20">20</option><option>21</option><option>22</option>
        </select>
    </div></div>


    <div @click="session_annee_change()" class="column colBorderThin is-3 isLink has-text-centered" style="">
        <span class="icon is-small has-text-success mt-3"><i class="fas fa-thumbs-up"></i></span>
    </div>

    <div @click="show_change_session=false" class="column colBorderThin is-2 isLink has-text-centered" style="">
        <span class="icon is-small has-text-danger mt-3"><i class="fas fa-minus-circle"></i></span>
    </div>



</div></div>

<div v-else class="column is-12" style="">
<div class="columns is-multiline is-gapless">
<div class="column is-1"></div>

<div class="column is-2 has-text-centered">
<a @click="session_annee_previous()" style="border: none;" class="button has-background-grey-dark has-text-warning"><span class="icon"><i class="fas fa-arrow-circle-left"></i></span></a> 
</div>

    <div @click="show_change_session=true" class="column is-6 box isLink has-background-info has-text-white is-size-4 has-text-centered has-text-weight-bold ">
        {{grp_sess}}-{{grp_ann}}
    </div>

<div class="column is-2 has-text-centered">
<a @click="session_annee_next()" style="border: none;" class="button is-borderless has-background-grey-dark has-text-warning"><span class="icon"><i class="fas fa-arrow-circle-right"></i></span></a> 
</div>

<div class="column is-1"></div>
</div></div>
<!-- END SESS/ANN STATIC  -->
</div>


<div v-if="show_change_session==false" class="columns is-multiline is-gapless box has-background-grey">

    <div class="column is-10 has-text-centered has-text-weight-bold">
            <p class="control has-icons-left"><input  v-model="search" v-on:keyup.enter="sort_search()" class="input is-fullwidth" type="text" placeholder="search">
            <span class="icon is-small is-left"><i class="fas fa-search" aria-hidden="true"></i></span></p>
    </div>
    <div @click="clear_search_search()" class="column colBorderThin is-2 isLink has-text-centered" style="">
        <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
    </div>

<div class="column is-1 is-size-7 has-text-light mt-2"> G. </div> 
<div class="column is-9"> 
        <div class="select is-fullwidth">
        <select v-model="data_menu_group_selected" @change="sort_this_shit()">
            <option value=""></option>
            <option v-for="(data,index) in data_menu_groups" :value="data"  :key="index" >{{ data }}</option>
        </select>
</div></div>
<div @click="clear_search_group()" class="column colBorderThin is-2 isLink has-text-centered" style="">
    <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
</div>

<div class="column is-1 is-size-7 has-text-light mt-2"> C. </div> 
<div class="column is-9"> 
        <div class="select is-fullwidth">
        <select v-model="data_menu_course_selected" @change="sort_this_shit()">
            <option value=""></option>
            <option v-for="(data,index) in data_menu_courses" :value="data"  :key="index" >{{ data }}</option>
        </select>
</div></div>
<div @click="clear_search_cour()" class="column colBorderThin is-2 isLink has-text-centered" style="">
    <span class="icon is-small has-text-light mt-3"><i class="fas fa-minus-circle"></i></span>
</div>
</div>








<div v-if="show_change_session==false" class="columns is-multiline is-gapless">
<!-- <div @click="get_students_ipr()" class="column colBorder isLink is-8 has-text-light">STUDENTS</div> <div @click="get_students_ipr()" class="column isLink has-text-centered colBorder is-4 has-text-light"> {{cnt_tran_ipr}}</div>
<div @click="get_courses()" class="column colBorder isLink is-8 has-text-light">COURSES</div><div @click="get_courses()" class="column isLink has-text-centered colBorder is-4 has-text-light">  {{cnt_tran_icr}}</div> -->

<!-- COUR NON SUIVI  -->
<div @click="show_nonsuivi=!show_nonsuivi" class="column colBorder isLink is-8 has-text-light">COUR NON SUIVI</div>
<div @click="show_nonsuivi=!show_nonsuivi" class="column isLink has-text-centered colBorder is-4 has-text-light">  {{cnt_tran_cns}} </div>

<!-- DECLARATION FINANCE  -->
<div @click="show_nonsuivi=!show_nonsuivi" class="column colBorder isLink is-8 has-text-light">DECLARE FINANCE</div>
<div @click="show_nonsuivi=!show_nonsuivi" class="column isLink has-text-centered colBorder is-4 has-text-light">  {{data_icr.cnt}} </div>


<!-- SYSEC  -->
<div class="column is-12 isLabel" style="margin-top:2em;">SYSEC</div>
<div class="column is-12">
<div class="control"><div class="select is-fullwidth">
    <select @change="get_osa_program_change()"  v-model="prog_sysec">
    <option value="NULL"></option>
    <option v-for="(prog,index) in data_programs" :value="prog.prog_ID"  :key="index" >{{ prog.prog_CODE }} {{ prog.prog_CODEPLUS }}</option>
    </select>
</div></div>
</div>

<div @click="get_osa()" class="column colBorder isLink is-6 has-text-light is-size-5 has-text-centered">OSA</div>

<div @click="get_set()" class="column colBorder isLink is-6 has-text-light is-size-5 has-text-centered">SET</div>

</div>


</div>  <!-- end box -->
</div> <!-- end SIDEBAR !!!! -->




<div id="mainContent" >



<div v-if="show_change_session==false" class="columns is-multiline" style="margin-top:-1.6em;">


<!-- <div class="column is-8"></div> -->


<!-- <div class="column is-4 has-background-white"> 
<div class="columns is-multiline is-gapless"> -->
<div class="column is-3 colBorderThinRight"> 
<div class="columns is-multiline is-gapless">
    <div class="column is-9 has-text-centered has-text-weight-bold" :class="return_style_selected('DID')">- DID -</div>
    <div class="column is-3 has-text-centered has-text-weight-bold" :class="return_style_selected('DID')">{{data_did.cnt}}</div>
    <div class="column is-12 has-text-centered" :class="return_style_selected('DID')"><PieChart :styles="style_chart_pie" :options="chartDefaults_pie" :chart-data="data_pie_did"></PieChart></div>
    <div @click="click_did('DONE')" class="column is-3 isLink has-text-centered colBorderThin has-text-weight-bold has-background-success" >{{data_did.done}}</div>
    <div @click="click_did_todo()" class="column is-3 isLink has-text-centered colBorderThin has-text-weight-bold has-background-info" >{{data_did.todo}}</div>
    <div @click="click_did('ERROR')" class="column is-3 isLink has-text-centered colBorderThin has-text-weight-bold has-background-danger" >{{data_did.error}}</div>
    <div @click="click_did('PENDING')" class="column is-3 isLink has-text-centered colBorderThin has-text-weight-bold has-background-warning" >{{data_did.pending}}</div>
</div></div>

<!-- <div class="column is-1"></div> -->

<div class="column is-3 colBorderThinRight"> 
<div class="columns is-multiline is-gapless">
    <div class="column is-9 has-text-centered has-text-weight-bold" :class="return_style_selected('IPR')">IPR</div>
    <div class="column is-3 has-text-centered has-text-weight-bold" :class="return_style_selected('IPR')">{{data_ipr.cnt}}</div>

    <div class="column is-12 has-text-centered" :class="return_style_selected('IPR')"><PieChart :styles="style_chart_pie" :options="chartDefaults_pie" :chart-data="data_pie_ipr"></PieChart></div>

    <div @click="click_ipr('DONE')" class="column is-3 isLink has-text-centered colBorderThin has-background-success">{{data_ipr.done}}</div>
    <div @click="click_ipr_todo()" class="column is-3 isLink has-text-centered colBorderThin has-background-info">{{data_ipr.todo}}</div>
    <div @click="click_ipr('ERROR')" class="column is-3 isLink has-text-centered colBorderThin" style="background-color:red;color:white">{{data_ipr.error}}</div>
    <div @click="click_ipr('PENDING')" class="column is-3 isLink has-text-centered colBorderThin has-background-warning">{{data_ipr.pending}}</div>
</div></div>
<!-- <div class="column is-1"></div>
</div></div> -->
 <!-- ** END DID/IPR **  -->
<!-- <div class="column is-1 has-background-grey-dark colBorderThinRight"> </div> -->
<!-- <div class="column is-8 has-background-white"> 
<div class="columns is-multiline is-gapless"> -->
<div class="column is-3 colBorderThinRight"> 
<div class="columns is-multiline is-gapless">
    <div class="column is-9 has-text-centered has-text-weight-bold" :class="return_style_selected('ICR')">ICR</div>
    <div class="column is-3 has-text-centered has-text-weight-bold" :class="return_style_selected('ICR')">{{data_icr.cnt}}</div>
    <div class="column is-12 has-text-centered" :class="return_style_selected('ICR')"><PieChart :styles="style_chart_pie" :options="chartDefaults_pie" :chart-data="data_pie_icr"></PieChart></div>
    <div @click="click_icr('DONE')" class="column is-3 isLink has-text-centered colBorderThin has-text-weight-bold" style="background-color:green;color:white">{{data_icr.done}}</div>
    <div @click="click_icr_todo()" class="column is-3 isLink has-text-centered colBorderThin has-background-info">{{data_icr.todo}}</div>
    <div @click="click_icr('ERROR')" class="column is-3 isLink has-text-centered colBorderThin" style="background-color:red;color:white">{{data_icr.error}}</div>
    <div @click="click_icr('PENDING')" class="column is-3 isLink has-text-centered colBorderThin has-background-warning">{{data_icr.pending}}</div>
</div></div>
<!-- <div class="column is-1"></div> -->
<div class="column is-3"> 
<div class="columns is-multiline is-gapless">
    <div class="column is-9 has-text-centered has-text-weight-bold" :class="return_style_selected('RCS')">RCS</div>
    <div class="column is-3 has-text-centered has-text-weight-bold" :class="return_style_selected('RCS')">{{data_rcs.cnt}}</div>
    <div class="column is-12 has-text-centered" :class="return_style_selected('RCS')"><PieChart :styles="style_chart_pie" :options="chartDefaults_pie" :chart-data="data_pie_rcs"></PieChart></div>
    <div @click="click_rcs('DONE')" class="column is-3 isLink has-text-centered colBorderThin has-text-weight-bold" style="background-color:green;color:white">{{data_rcs.done}}</div>
    <div @click="click_rcs_todo()" class="column is-3 isLink has-text-centered colBorderThin has-background-info">{{data_rcs.todo}}</div>
    <div @click="click_rcs('ERROR')" class="column is-3 isLink has-text-centered colBorderThin" style="background-color:red;color:white">{{data_rcs.error}}</div>
    <div @click="click_rcs('PENDING')" class="column is-3 isLink has-text-centered colBorderThin has-background-warning">{{data_rcs.pending}}</div>
</div></div>
<!-- <div class="column is-1"></div> -->
<div v-if="show_nonsuivi==true" class="column is-3"> 
<div class="columns is-multiline is-gapless">
    <div class="column is-9 has-text-centered has-text-weight-bold" :class="return_style_selected('CNS')">CNS</div>
    <div class="column is-3 has-text-centered has-text-weight-bold" :class="return_style_selected('CNS')">{{data_cns.cnt}}</div>
    <div class="column is-12 has-text-centered " :class="return_style_selected('CNS')"><PieChart :styles="style_chart_pie" :options="chartDefaults_pie" :chart-data="data_pie_cns"></PieChart></div>
    <div @click="click_cns('DONE')" class="column is-3 isLink has-text-centered colBorderThin has-text-weight-bold" style="background-color:green;color:white">{{data_cns.done}}</div>
    <div @click="click_cns_todo()" class="column is-3 isLink has-text-centered colBorderThin has-background-info">{{data_cns.todo}}</div>
    <div @click="click_cns('ERROR')" class="column is-3 isLink has-text-centered colBorderThin" style="background-color:red;color:white">{{data_cns.error}}</div>
    <div @click="click_cns('PENDING')"  class="column is-3 isLink has-text-centered colBorderThin has-background-warning">{{data_cns.pending}}</div>
</div></div>


<!-- </div></div> -->
 <!-- ** END ICR/RCS/CNS **  -->


<!-- SUMMARY BOX  -->
<div v-if="transmission_type!=''" class="column is-12 has-background-grey-dark" style="margin-top:-.8em;">
<div class="columns is-gapless is-multiline" style="margin-bottom:-.8em;margin-top:0em;">
<div class="column is-1 has-text-centered has-text-weight-bold is-size-3 has-text-light">{{transmission_type}}</div>

<div class="column is-2 "> 
        <a @click="process_select_all()" class="button is-fullwidth has-background-white has-text-black">
            <span class="icon is-small"><i class="fas fa-hand-pointer"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;SELECT ALL
        </a> 
</div>

<!-- CHECK IF IPR -- SHOw SEMESTER ??? -->

<div v-if="transmission_type=='IPR'" class="column is-3">
    <div class="columns is-gapless">
        <div class="column is-8 has-text-right has-text-white"># semestre&nbsp;</div>
        <div class="column is-4"><input  v-model="session_ipr" class="input is-fullwidth has-text-centered has-text-weight-bold" type="text" placeholder="...."></div>
    </div>
     
</div>          
<div v-else class="column is-3"></div>

<div class="column is-3"></div>

<!-- NAV BUTTONS  -->
<div class="column is-2" style=""><div class="columns is-gapless">
<div @click="pagination_previous()" class="column is-3 has-text-centered"> 
        <a class="button is-fullwidth has-background-white has-text-black">
            <span class="icon"><i class="fas fa-arrow-circle-left fa-2x"></i></span>
        </a> 
</div>
<div class="column is-6 has-text-weight-bold mt-2 has-text-centered has-text-light">
    {{display_string}}
</div>
<div @click="pagination_next()" class="column is-3  has-text-centered"> 
        <a class="button is-fullwidth has-background-white has-text-black">
            <span class="icon"><i class="fas fa-arrow-circle-right fa-2x"></i></span>
        </a> 
</div>   

</div></div>

<div class="column is-1"></div>

</div></div>
<!-- END SUMARY  -->


<!-- SHOW STUDENTS OSA -->
<div v-if="transmission_type == 'OSA'" class="column is-12" style="margin-top:1em;">
<div v-if="data_comps_unique.length > 0" class="columns is-multiline">
    <div class="column is-4" style="" v-for ="(info, index) in data_comps_unique" :key="randomKey(index)">
        <TranmissionOSA 
            :comp="info"
            :comps_all="data_comps"
            :studs="data_students_osa"
            :sessann="grp_sess + grp_ann"
            :key="randomKey()">
        </TranmissionOSA>
    </div>
</div></div>
<!-- END SHOW STUDENTS OSA-->






<!-- SHOW STUDENTS OTHER TRANS (IPR, ....) -->
<div v-else class="column is-12" style="margin-top:-1em;">
<div v-if="data_students_show.length > 0" class="columns  is-gapless is-multiline">
    <div class="column is-4" style="" v-for ="(info, index) in data_students_page" :key="randomKey(index)">
        <Tranmission 
            :stud="info"
            :type="transmission_type"
            :status='transmission_status_selected'
            :selected='check_tran_selected(info.studID,info.group_ID,transmission_type)' 

            :key="randomKey()">
        </Tranmission>
    </div>
</div></div>
<!-- END SHOW STUDENTS OTHER TRANS (IPR, ....)  -->

            <!-- 
            
            

                        @emit_hop_on="emit_hop_on"
            -->


</div>
<!-- !!!! END NEW CONTENT -- PIES AND SUCH !  -->









</div> <!-- END CONTAINER -->
</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { bus } from '@/main'
var xml2js = require('xml2js');


import PieChart from '@/components/charts/Chart_Pie'
import LineChart from '@/components/charts/Chart_Line'

import js_transmit from '../../assets/js/js_transmit.js'
 
import TranProto  from '@/views/Dossier/Tran_Proto';

import TranStud  from '@/components/Comp_Tran_Student';
import TranCourse  from '@/components/Comp_Tran_Course';
import TranCourseMain  from '@/components/Comp_Tran_Course_Main';


import Tranmission  from '@/components/Comp_Transmission';
import TranmissionOSA  from '@/components/Comp_Transmission_OSA';
import TranResult  from '@/components/Comp_Tran_Results';

export default {
        props: [ ],
        components: {Tranmission, TranmissionOSA, TranResult, TranStud, TranCourse, TranCourseMain, TranProto , PieChart, LineChart},

        data() {
            return {
                isLoading:false,
                navOpen:false,

                search:'',
                grp_sess:'', // ********************** LOAD !!!!!!!!!!!!!!!!!!
                grp_ann:'',

session_ipr:1,


show_nonsuivi : false,

data_students_all:[],
data_students_unique:[],
data_students_ipr:[],
data_students_did:[],

data_students_show:[],
data_students_page:[],

data_files_pending:[],
data_files:[],

// data_files_icr:[],

transmission_status_selected:'',
transmission_type:'',

data_did:{cnt:0,done:0,todo:0,error:0,pending:0}, data_pie_did:null,
data_ipr:{cnt:0,done:0,todo:0,error:0,pending:0}, data_pie_ipr:null,
data_icr:{cnt:0,done:0,todo:0,error:0,pending:0}, data_pie_icr:null,
data_rcs:{cnt:0,done:0,todo:0,error:0,pending:0}, data_pie_rcs:null,
data_cns:{cnt:0,done:0,todo:0,error:0,pending:0}, data_pie_cns:null,

display_string:'',
display_count:0,
display_total:0,
display_max:60,
display_offset:0,

chartDefaults_pie : {
    legend: {display: false},
    responsive: true,
    maintainAspectRatio: false,
},

chartDefaults_line : {
    legend: {display: true},
    responsive: true, maintainAspectRatio: false,
    // onClick: this.chart_point_click,
    scales: {
        xAxes: [{ticks: {fontSize: 14,fontStyle: "bold",}}],
        yAxes: [{ticks: {fontSize: 14,fontStyle: "bold",}}]
    }
}, // END CHART DEFAULT


data_view: '',

data_menu_courses:[],
data_menu_groups:[], // HOLDS DISTINCT GROUP CODES
data_menu_group_selected:'',
data_menu_course_selected:'',


data_code_session : '', // HOLDS THE SELECTED GROUP



// FOR GETTING DID
dt_sess_start: '',
dt_sess_end: '',

                data_transmission:[],
                data_menu:[],
                data_students:[],

                data_groups:[],
                data_students_groups:[],

data_programs:[], // SYSEC
prog_sysec: '',
data_students_osa:[],
data_students_set:[],

data_comps:[],
data_comps_unique:[],


data_students_file:[],
cnt_files_pending:0,


data_toTransmit:[], // HOLDS THE STUDENTS TO SEND
data_confirm:[], // HOLDS DATA TO CONFIRM SEnD

data_transmit:[],
cnt_add:0,
cnt_mod:0,
cnt_del:0,
cnt_total:0,
cnt:0,

cnt_tran_ipr:0,
cnt_tran_icr:0,
cnt_tran_rcs:0,
cnt_tran_cns:0,

show_change_session:false,


file_message_1:'',
file_message_2:'',
file_message_3:'',

errorCount:0,
data_errors:[],

            }
        },

/* mounted: function () {
  this.$nextTick(function () {
    // Code that will run only after the
    // entire view has been rendered
    alert('done!')
  })
}, */

computed: {
    style_chart_line() {
        return {
        height: '40vh',  
        position: 'relative',
        };
    },  
    style_chart_pie() {
        return {
        height: '8vh',  
        position: 'relative',
        };
    },
},
// END COMPUTED

created() {



    bus.$on('hop_on_for_tran', (data, tranTYPE, operation, tranID) => {
        this.data_toTransmit.push({data : data,tranTYPE : tranTYPE, operation : operation, id : tranID});
 
        // DID -- ADD CIT/ADR
        // if (tranTYPE == 'DID') {
        //     this.data_toTransmit.push({data : data,tranTYPE : 'CIT', operation : operation, id : 'CIT:' + tranID});
        //     // this.data_toTransmit.push({data : data,tranTYPE : 'ADR', operation : operation, id : 'ADR:' + tranID});
        // }

        switch(operation) {  // UPDATE TOTALS
            case "C": this.cnt_add += 1;break;
            case "M": this.cnt_mod += 1;break;
            case "A": this.cnt_del += 1;break;
        }
    }) // END HOP ON -- , tranTYPE

    bus.$on('hop_off_for_tran', (tranID , tranTYPE) => {

console.log(tranID)
var indx = this.data_toTransmit.findIndex(x => x.id == tranID);



        for (var i = 0; i < this.data_toTransmit.length; i++) {
           if (this.data_toTransmit[i].id  == tranID) 
           {
            switch(this.data_toTransmit[i].operation) {  // UPDATE TOTALS
                case "C": this.cnt_add -= 1;break;
                case "M": this.cnt_mod -= 1;break;
                case "A": this.cnt_del -= 1;break;
            }               
            this.data_toTransmit.splice(i,1) ;}
        }

        // DID -- ADD CIT/ADR
        if (tranTYPE == 'DID') {
            for (var i = 0; i < this.data_toTransmit.length; i++) {
                if (this.data_toTransmit[i].id  == 'CIT:' + tranID)  {this.data_toTransmit.splice(i,1)}
                if (this.data_toTransmit[i].id  == 'ADR:' + tranID)  {this.data_toTransmit.splice(i,1)}
            } // END FOR

        }

    }); // END HOP OFF


this.data_view = ''

// SET INITIAL SESSION/ANNEE
var sessann = moment().format('M')
if (sessann < 5)  { this.grp_sess = 'H'} else if (sessann < 8) { this.grp_sess = 'E'} else  { this.grp_sess = 'A'}
this.grp_ann =  moment().format('YY')

// SET START/END DATE OF SESS/ANN
if (this.grp_sess == 'H') {this.dt_sess_start = "20"+this.grp_ann+"-01-01" ; this.dt_sess_end = "20"+this.grp_ann+"-04-30"}
else if (this.grp_sess == 'E') {this.dt_sess_start = "20"+this.grp_ann+"-05-01" ; this.dt_sess_end = "20"+this.grp_ann+"-08-31"}
else {this.dt_sess_start = "20"+this.grp_ann+"-09-01" ; this.dt_sess_end = "20"+this.grp_ann+"-12-31"}


// GET PROGRAMS
var query = "SELECT * FROM MyMEQ_PROGRAM"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.data_programs = res.data

// GET NUMBER OF FILES PENDING !!
var query =  "SELECT COUNT(fileTran_ID) AS cnt FROM myMEQ_FILE_TRAN WHERE fileTran_STATUS = 'PENDING'"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.cnt_files_pending = res.data[0].cnt

    setTimeout(() => { this.openNav(); }, 500);  
    this.sort_this_shit()

});  });



}, // ---- END CREATED 

methods: {

validate_data:function(stud){
// DO VALIDATION FOR COMMON FILEDS
    if (!stud.student_CodePerm || stud.student_CodePerm.length != 12) {stud.hasErrors += 'CODE PERM * '}
    if (!stud.student_NumAdmission || stud.student_NumAdmission.length == 0 || stud.student_NumAdmission.length > 9) {stud.hasErrors += ' NUM ADMISSION * '}
    if (!stud.student_lNAME || stud.student_lNAME.length == 0 || stud.student_lNAME.length > 40) {stud.hasErrors += ' NOM DE FAMILLE * '}
    if (!stud.student_fNAME || stud.student_fNAME.length == 0 || stud.student_fNAME.length > 25) {stud.hasErrors += ' PRÉNOM * '}

// DID
if (this.transmission_type == 'DID') {
    if (!stud.matLang || this.return_tran_data(stud.matLang).length != 2 ) {stud.hasErrors += " Langue maternelle * "}
    if (!stud.useLang || this.return_tran_data(stud.useLang).length != 2 ) {stud.hasErrors += " Langue utilisée * "}
    if (!stud.status || this.return_tran_data(stud.status).length != 2 ) {stud.hasErrors += " Statut légal au Canada * "}
    if (!stud.status_entDATE) {stud.hasErrors += " Date Statut légal au Canada * "}

    if (!stud.codePAYS || this.return_tran_data(stud.codePAYS).length != 3 ) {stud.hasErrors += " Code de pays de citoyenneté * "}
    if (!stud.criteria || this.return_tran_data(stud.criteria).length != 2 ) {stud.hasErrors += " Critère pour établir le statut de résident du Québec * "}
    if (!stud.autoCAN || this.return_tran_data(stud.autoCAN).length != 2 ) {stud.hasErrors += " Autorisation pour étudier au Canada * "}
    if (!stud.autoQC || this.return_tran_data(stud.autoQC).length > 3 ) {stud.hasErrors += " Autorisation pour étudier au Québec * "}
    if (!stud.mobilite || this.return_tran_data(stud.mobilite).length != 2 ) {stud.hasErrors += " Entente sur la mobilité * "}
    if (!stud.exemption || this.return_tran_data(stud.exemption).length > 3 ) {stud.hasErrors += " Condition particulière d’exemption de montant forfaitaire * "}
    if (!stud.document || this.return_tran_data(stud.document).length != 1 ) {stud.hasErrors += " indicateur Detention Document * "}
    // if (!stud.reference || this.return_tran_data(stud.reference).length > 6 ) {stud.hasErrors += " Code d’organisme de référence pour les données de citoyenneté * "}

// }
// if (this.transmission_type == 'ADR') { // ADR

console.log("RUE: " + stud.student_rueNum)

    if (!stud.student_rueNUM) {stud.hasErrors += ' numero Immeuble * '}    
    if (!stud.student_Address) {stud.hasErrors += ' address * '}
    //if (!stud.prog_CODE || stud.prog_CODE.length != 6) {stud.hasErrors += ' nom Rue * '}
    // if (!stud.prog_CODE || stud.prog_CODE.length != 6) {stud.hasErrors += ' appartement * '}
    if (!stud.student_City) {stud.hasErrors += ' city * '}
    if (!stud.student_Postal) {stud.hasErrors += ' code Postal * '}
    if (!stud.codePAYS) {stud.hasErrors += ' country (address) * '}
    if (!stud.codePROVINCE) {stud.hasErrors += ' province * '}
    if (!this.validatePhonenumber(stud.student_TelHome) && !this.validatePhonenumber(stud.student_TelOther)) {stud.hasErrors += ' numero Telephone Personnel  * '}
}

// IPR
if (this.transmission_type == 'IPR') {
    if (!stud.service || this.return_tran_data(stud.service).length != 1 ) {stud.hasErrors += " Service d'enseignement * "}
    if (!stud.prog_CODE || stud.prog_CODE.length != 6) {stud.hasErrors += ' PROGRAM * '}
    if (!stud.prog_YEAR || stud.prog_YEAR.length != 4) {stud.hasErrors += ' PROGRAM YEAR * '}

    if (!stud.typeScolaire || this.return_tran_data(stud.typeScolaire).length != 3 ) {stud.hasErrors += " Frequentation Scolaire * "}
    if (!stud.conditionProgram || this.return_tran_data(stud.conditionProgram).length != 3 ) {stud.hasErrors += " conditions Admission Programme * "}
    if (!stud.conditionAdmission || this.return_tran_data(stud.conditionAdmission).length != 1 ) {stud.hasErrors += " condition Specifique Admission AEC * "}
    if (!stud.situation || this.return_tran_data(stud.situation).length != 2 ) {stud.hasErrors += " situation Eleve Temps Partiel Repute Temps Plein * "}
    if (!stud.indicatorATE || this.return_tran_data(stud.indicatorATE).length != 1 ) {stud.hasErrors += " indicateur ATE * "}
    if (!stud.indicatorBACC || this.return_tran_data(stud.indicatorBACC).length != 1 ) {stud.hasErrors += " indicateur Cheminement Dec Bacc * "}
    if (!stud.indicatorEMPLOY || this.return_tran_data(stud.indicatorEMPLOY).length != 1 ) {stud.hasErrors += " indicateur Programme Refere Emploi Quebec * "}
    if (!stud.indicatorPRO || this.return_tran_data(stud.indicatorPRO).length != 1 ) {stud.hasErrors += " indicateur Programme Refere Ordre Professionnel * "}
    if (!stud.indicatorCARC || this.return_tran_data(stud.indicatorCARC).length != 1 ) {stud.hasErrors += " indicateur Milieu Carceral * "}
    if (!stud.indicatorRELIGION || this.return_tran_data(stud.indicatorRELIGION).length != 1 ) {stud.hasErrors += " indicateur Groupe Religion Specifique * "}
    if (!stud.indicatorVOYAGE || this.return_tran_data(stud.indicatorVOYAGE).length != 1 ) {stud.hasErrors += " indicateur Voyage Autour Monde  * "}
    
}





// ICR
    if (this.transmission_type == 'ICR') {
        if (!stud.service || this.return_tran_data(stud.service).length != 1 ) {stud.hasErrors += " Service d'enseignement * "}
        if (!stud.prog_CODE || stud.prog_CODE.length != 6) {stud.hasErrors += ' PROGRAM * '}
        if (!stud.prog_YEAR || stud.prog_YEAR.length != 4) {stud.hasErrors += ' PROGRAM YEAR * '}

        if (!stud.typeFinance || this.return_tran_data(stud.typeFinance).length != 2 ) {stud.hasErrors += " type Composante Financement Cours  * "}
        if (!stud.typeFormation || this.return_tran_data(stud.typeFormation).length != 2 ) {stud.hasErrors += " type Reconnaissance Acquis Formation * "}
        if (!stud.mode || this.return_tran_data(stud.mode).length != 2 ) {stud.hasErrors += " mode Enseignement Distance  * "}
        if (!stud.sub || this.return_tran_data(stud.sub).length != 1 ) {stud.hasErrors += " indicateur Intention Substitution * "}
        if (!stud.situationOrg || this.return_tran_data(stud.situationOrg).length != 2 ) {stud.hasErrors += " situation Etudes Organisme Partenaire  * "}

    } 

// CNS
    if (this.transmission_type == 'CNS') {
        if (!stud.prog_CODE || stud.prog_CODE.length != 6) {stud.hasErrors += ' PROGRAM * '}
        if (!stud.prog_YEAR || stud.prog_YEAR.length != 4) {stud.hasErrors += ' PROGRAM YEAR * '}
    } 

// RCS
    if (this.transmission_type == 'RCS') {
        if (!stud.group_AVG) {stud.hasErrors += ' COUR MOYEN * '}
        if (!stud.cs_MARK && !stud.cs_REMARK) {stud.hasErrors += ' NO RESULT * '}
    }    

    return stud
}, // END VALIDATE

validatePhonenumber:function(pho) {
//CHECK IF VALID CELL
    if (!pho) {return false}

  var phoneno = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  if(pho.match(phoneno)) {return true;}
  else {return false;}
},


return_tran_data:function(data) {
// RETURN ONLY THE TRAN VALUE ---- 
    if (!data) {return ''}
    if (data.indexOf('=') == -1) {return ''}


console.log(data.substring(0,data.indexOf('=')).trim())
    return data.substring(0,data.indexOf('=')).trim()

},



check_file_confirm:function(index){
 
setTimeout(() => { 
    if (this.data_files_pending[index].fileConfirm == true)
    {return true} else {return false}
}, 100);

},


emit_hop_on:function(data, tranTYPE, operation, tranID) {



        this.data_toTransmit.push({data : data,tranTYPE : tranTYPE, operation : operation, id : tranID});
 
         switch(operation) {  // UPDATE TOTALS
            case "C": this.cnt_add += 1;break;
            case "M": this.cnt_mod += 1;break;
            case "A": this.cnt_del += 1;break;
        }


},

put_file_ftp:function() {
// GET THE FILE FROM FTP SITE
    axios.get(this.$url+'/ftp_put_file')
    .then(res => { 
        console.log(res)
    });
},

get_file_ftp:function() {
// GET THE FILE FROM FTP SITE
    axios.get(this.$url+'/ftp_get_file')
    .then(res => { 
        console.log(res)
    });
},

process_file:function(index, fiID,fiFTP_CON,fiFTP_DET){



    this.errorCount = 0 
    this.data_errors = []

    // CHECK OPEN --
    if (this.data_files_pending[index].fileShow == 1) 
    {this.data_files_pending[index].fileShow = 0 ; return}

// SHOW DETAILS ....
    this.data_files_pending[index].fileShow = 1

    // IF DETAIL FILE -- JUST PROCESS THAT
    var fileToProcess = ''
    if (fiFTP_DET != '') {fileToProcess = fiFTP_DET}
    else {fileToProcess = fiFTP_CON} 


// alert (fileToProcess)

    var ecole=sessionStorage.getItem('college_nickname')
    axios.get(this.$url+'/file_decrypt_II?filetran='+fileToProcess+'&ecole='+ecole)
    .then(res => { 
        // RETURNS DATA
        var retData = res.data

// CHECK IF DOING CONFIRMATION/DETAIL
        if (fiFTP_DET != '') {this.read_file ( fiID ,retData )}
        else {this.read_file_confirm ( fiID ,retData )}        

        
    });


},

read_file_confirm:function(fileID,tranData) {
    this.isLoading = true;

    this.file_message_1 = ""
    this.file_message_2 = ""

    var self = this;
    xml2js.parseString(tranData, {explicitArray : false}, function (err, result) {
    var jResult = result


// CHECK FOR ERROR
    if (jResult.ECH01020299.commande.listeMessageCommande.messageCommande) {
    // ---- has error
        var errMessage = jResult.ECH01020299.commande.listeMessageCommande.messageCommande.message + "|"
        var jMessage = jResult.ECH01020299.commande.listeMessageCommande.messageCommande
            if (Array.isArray(jMessage.listeMessageAddionnel.messageAdditionnel)) { 
                for (var err_key in jMessage.listeMessageAddionnel.messageAdditionnel) { 
                    errMessage += jMessage.listeMessageAddionnel.messageAdditionnel[err_key] + "|"
                }
            } else {
                errMessage += jMessage.listeMessageAddionnel.messageAdditionnel + "|"
            }

    // ---- done processing error - do something .
            var query = `UPDATE myMEQ_FILE_TRAN SET fileTran_STATUS = 'ERROR', fileTran_COMMENTS = fileTran_COMMENTS + ' : ' + '`+ errMessage.replace(/'/g,"''") + `'  WHERE (fileTran_ID = ` + fileID + `) ;`           
            axios.get(self.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
            .then(res => {    
                self.isLoading = false;
            });

// !!!! NEED TO UPDATE STUDENT FILES !!!!




            self.file_message_1 = errMessage
    } // ---- end if error ----
        
    else {

    // console.log(jResult)
    var iSent = jResult.ECH01020299.commande.nbDemandesTransmises
    var iGood = jResult.ECH01020299.commande.nbDemandesAcceptees

    self.file_message_1 = "SENT : " + iSent
    self.file_message_2 = "GOOD : " + iGood

    var iOK = 1
    if (iSent != iGood) {iOK = 0}

    var query = `UPDATE myMEQ_FILE_TRAN SET fileTran_blnACCEPTED = ` + iOK + ` WHERE fileTran_ID = ` + fileID
// console.log(query)
    axios.get(self.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {    
        self.isLoading = false;
    });

} // end if checkign error
 



    }); // END XMLjs


},


read_file:function(fileID,tranData) {

// KICK THINGS OFF
    this.isLoading = true; 
    var self = this;
// READ XML
    xml2js.parseString(tranData, {explicitArray : false}, function (err, result) {
    var jResult = result 
// GET STUDENTS
    var query = `SELECT 'DONE' AS outcome, '' AS error, 0 AS processed, myMEQ_TRAN_MASTER.student_ID, fileTran_TYPE, myMEQ_TRAN_MASTER.tran_tran_ID, 
    MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_GRPCODE 
    FROM myMEQ_FILE_TRAN INNER JOIN myMEQ_TRAN_MASTER ON myMEQ_FILE_TRAN.fileTran_ID = myMEQ_TRAN_MASTER.fileTran_ID 
    INNER JOIN MyMEQ_STUDENT ON myMEQ_TRAN_MASTER.student_ID = MyMEQ_STUDENT.student_ID WHERE (myMEQ_FILE_TRAN.fileTran_ID = ` + fileID + `)`
    axios.get(self.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {
        self.data_students_file = res.data

// CHECK FOR ERRORS (XML FILE)
        var jTransaction = jResult.ECH01020298.listeTransaction.transactionSysteme
// HAS MULTIPLE ERRORs / WARNINGs!
        if (Array.isArray(jTransaction)) { 
            for (var err_key in jTransaction) {
                var tranID = jTransaction[err_key].identificationTransaction



// NEED TO CHECK IF ARRAY OF ERRORs
var jERRlist = jTransaction[err_key].listeMessageTransactionSysteme.messageTransactionSysteme
// console.log(jERRlist)
        if (Array.isArray(jERRlist)) { 
            for (var err_list in jERRlist) {

var tran = jTransaction[err_key].listeMessageTransactionSysteme.messageTransactionSysteme[err_list]
if (tran.consequenceTransaction == 'R') {
                    var indexStud = self.data_students_file.findIndex(x => (x.tran_tran_ID == tranID));
                    self.data_students_file[indexStud].outcome = 'ERROR'
                    self.data_students_file[indexStud].error +=  tran.descriptionMessageTransactionSysteme.replace(/�/g,"é") + '    '

    console.log('**** ' + tranID + ' ****')
    console.log('**** ' + tran.descriptionMessageTransactionSysteme.replace(/�/g,"é") + ' ****')
}

            }
        } else {
                var jERR = jTransaction[err_key].listeMessageTransactionSysteme.messageTransactionSysteme
// IGNORE WARNINGS
                if (jERR.consequenceTransaction == 'R') {
// UPDATE STUD DATA
console.log('**** ' + tranID + ' ERROR ****')
                    var indexStud = self.data_students_file.findIndex(x => (x.tran_tran_ID == tranID));
                    self.data_students_file[indexStud].outcome = 'ERROR'
                    self.data_students_file[indexStud].error +=  jERR.descriptionMessageTransactionSysteme.replace(/�/g,"é") + '    '
                } // END IF CONSEQUENCE IS ERROR
        }





            } // END FOR (LOOP ERRORS)
        } else {     
// ERROR :::: CHECK IF ONE
            if (jTransaction) {
                var tranID1 = jTransaction.identificationTransaction
                var jERR1 = jTransaction.listeMessageTransactionSysteme.messageTransactionSysteme
// IGNORE WARNINGS
                if (jERR1.consequenceTransaction == 'R') {
// UPDATE STUD DATA
                    var indexStud1 = self.data_students_file.findIndex(x => (x.tran_tran_ID == tranID1));
                    self.data_students_file[indexStud1].outcome = 'ERROR'
                    self.data_students_file[indexStud1].error +=  jERR1.descriptionMessageTransactionSysteme.replace(/�/g,"é") + '    '

                } // END IF CONSEQUENCE IS ERROR


            } // END CHECK IF ONE ERROR
        } // END MAIN IF


    }) // END AXIOS
    }) // END XML PARSE 



// GIVE IT A SECOND .... create update query ---- 
setTimeout(() => { 

var queryMaster = ' '
for (var x = 0; x < self.data_students_file.length; x++) {
    switch(self.data_students_file[x].fileTran_TYPE) {

        case 'DID':
            queryMaster += `UPDATE myMEQ_STUDENT SET did_status = '` + self.data_students_file[x].outcome + `',  did_message = '` + self.chk_string(self.data_students_file[x].error) + `' WHERE did_id = '` + self.data_students_file[x].tran_tran_ID + `' ; `
            break;

        case 'IPR':
            queryMaster += `UPDATE myMEQ_STUDENT_IPR SET ipr_status = '` + self.data_students_file[x].outcome + `',  ipr_message = '` + self.chk_string(self.data_students_file[x].error) + `' WHERE ipr_id = '` + self.data_students_file[x].tran_tran_ID + `' ; `
            break;

        case 'ICR':
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET icr_status = '` + self.data_students_file[x].outcome + `', icr_message = '` + self.chk_string(self.data_students_file[x].error) + `' WHERE (icr_id = '` + self.data_students_file[x].tran_tran_ID + `') ;`
            break;

        case 'RCS':
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET rcs_status = '` + self.data_students_file[x].outcome + `', rcs_message = '` + self.chk_string(self.data_students_file[x].error) + `' WHERE (rcs_id = '` + self.data_students_file[x].tran_tran_ID + `') ;` 
            break;

        case 'CNS':
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET cns_status = '` + self.data_students_file[x].outcome + `', cns_message = '` + self.chk_string(self.data_students_file[x].error) + `' WHERE (cns_id = '` + self.data_students_file[x].tran_tran_ID + `') ;` 
            break;

    } // END SWITCH TRAN TYPE
} // END LOOPING STUDENTS


// GIVE IT A SECOND .... run query ---- 
setTimeout(() => {

// console.log(self.data_students_file)
// console.log(' ------------------- ')
// console.log(queryMaster)


// UPDATE MASTER FILE (_FILE_TRAN)
    queryMaster += `UPDATE myMEQ_FILE_TRAN SET fileTran_STATUS = 'ACCEPT' WHERE (fileTran_ID = ` + fileID + `) ;`
    axios({
        method: 'post',
        url: self.$url+sessionStorage.getItem('url_query_form'),
        data: {query:encodeURIComponent(queryMaster)},
    })
    .then(res => {
        self.isLoading = false;
    });



}, 400); // END QUERY RUN TIMEOUT ----


}, 400); // END QUERY CONSTRUCT TIMEOUT ----



},




read_file_X:function(fileID,tranData) {

this.isLoading = true;


    var self = this;
    xml2js.parseString(tranData, {explicitArray : false}, function (err, result) {
    var jResult = result

// console.log(jResult)


        // GET THE FILE ID
        var fileNAME = jResult.ECH01020298.$.nomFichier.replace(/\.[^/.]+$/, "") ;


// GET STUDENTS
var query = `SELECT 'DONE' AS outcome, 0 AS processed, myMEQ_TRAN_MASTER.student_ID, fileTran_TYPE, myMEQ_TRAN_MASTER.tran_tran_ID FROM myMEQ_FILE_TRAN INNER JOIN myMEQ_TRAN_MASTER ON myMEQ_FILE_TRAN.fileTran_ID = myMEQ_TRAN_MASTER.fileTran_ID
WHERE (myMEQ_FILE_TRAN.fileTran_ID = ` + fileID + `)`
console.log(query)
axios.get(self.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    self.data_students_file = res.data

// NUMBER SENT
    self.file_message_1 = "SENT : " + self.data_students_file.length
    

    var queryMaster = ``



        //ERRORS
        var jTransaction = jResult.ECH01020298.listeTransaction.transactionSysteme
        

        // CHECK FOR RESULTS
        if (self.isArray(jTransaction)) { // HAS MULTIPLE ERRORs / WARNINGs!
            for (var err_key in jTransaction) {

self.errorCount++

                console.log(err_key)
                var tranID = jTransaction[err_key].identificationTransaction
                // console.log(tranID)  console.log(jERR.descriptionMessageTransactionSysteme)
                var jERR = jTransaction[err_key].listeMessageTransactionSysteme.messageTransactionSysteme
                
// FIND INDEX FROM ID
var indexStud = self.data_students_file.findIndex(x => (x.tran_tran_ID == tranID));
self.data_students_file[indexStud].outcome = jERR

var obj = {};
obj.student = "STUD NAME"
obj.outcome = jERR.consequenceTransaction
obj.error = jERR.descriptionMessageTransactionSysteme
self.data_errors.push(obj)

// ---- CHECK IF ERROR OR WARNING ....
var returnOutcome = 'ERROR'
if (jERR.consequenceTransaction == 'A') {returnOutcome = 'DONE'}
// MARK PROCESSED :: FOR UPDATING NON ERRORS
self.data_students_file[indexStud].processed = 1

switch(self.data_students_file[0].fileTran_TYPE) {

// -----------------------------------------------------------------
    case 'IPR':
            queryMaster += `UPDATE myMEQ_STUDENT_IPR SET ipr_status = '` + returnOutcome + `', ipr_message = '` + jERR.descriptionMessageTransactionSysteme.replace(/'/g,"''") + `' WHERE (ipr_id = '` + self.data_students_file[indexStud].tran_tran_ID + `') ;` 
    break;
// -----------------------------------------------------------------


// -----------------------------------------------------------------
    case 'ICR':
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET icr_status = '` + returnOutcome + `', icr_message = '` + jERR.descriptionMessageTransactionSysteme.replace(/'/g,"''") + `' WHERE (icr_id = '` + self.data_students_file[indexStud].tran_tran_ID + `') ;` 
    break;
// -----------------------------------------------------------------


// -----------------------------------------------------------------
    case 'RCS':
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET rcs_status = '` + returnOutcome + `', rcs_message = '` + jERR.descriptionMessageTransactionSysteme.replace(/'/g,"''") + `' WHERE (rcs_id = '` + self.data_students_file[indexStud].tran_tran_ID + `') ;` 
    break;
// -----------------------------------------------------------------


// -----------------------------------------------------------------
    case 'CNS':
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET cns_status = '` + returnOutcome + `', cns_message = '` + jERR.descriptionMessageTransactionSysteme.replace(/'/g,"''") + `' WHERE (cns_id = '` + self.data_students_file[indexStud].tran_tran_ID + `') ;` 
    break;
// -----------------------------------------------------------------

  default:
    // code block
} 


            }            
        } else { // ERROR :::: ONE OR NONE
            if (!jTransaction) {
                // HAS NO ERRORS! 
                self.errorCount = 0

var qStuds = ``
switch(self.data_students_file[0].fileTran_TYPE) {

// -----------------------------------------------------------------
  case 'IPR':
        for (var x = 0; x < self.data_students_file.length; x++) {qStuds += ` (ipr_id = '` + self.data_students_file[x].tran_tran_ID + `') OR `}
        qStuds = qStuds.substring(0, qStuds.length-3); // REMOVE LAST -OR-
        queryMaster = `UPDATE myMEQ_STUDENT_IPR SET ipr_status = 'DONE' WHERE ` + qStuds
    break;
// -----------------------------------------------------------------

// -----------------------------------------------------------------
  case 'ICR':
        for (var x = 0; x < self.data_students_file.length; x++) {qStuds += ` (icr_id = '` + self.data_students_file[x].tran_tran_ID + `') OR `}
        qStuds = qStuds.substring(0, qStuds.length-3); // REMOVE LAST -OR-
        queryMaster = `UPDATE MyMEQ_COURSESTUDENT SET icr_status = 'DONE' WHERE ` + qStuds
    break;
// -----------------------------------------------------------------

// -----------------------------------------------------------------
  case 'RCS':
        for (var x = 0; x < self.data_students_file.length; x++) {qStuds += ` (rcs_id = '` + self.data_students_file[x].tran_tran_ID + `') OR `}
        qStuds = qStuds.substring(0, qStuds.length-3); // REMOVE LAST -OR-
        queryMaster = `UPDATE MyMEQ_COURSESTUDENT SET rcs_status = 'DONE' WHERE ` + qStuds
    break;
// -----------------------------------------------------------------


  default:
    // code block
} 


                
            } else {
                // HAS ONE ERROR! 
                self.errorCount = 1

                var tranID = jTransaction.identificationTransaction
                var jERR = jTransaction.listeMessageTransactionSysteme.messageTransactionSysteme

var obj = {};
obj.student = "STUD NAME"
obj.outcome = jERR.consequenceTransaction
obj.error = jERR.descriptionMessageTransactionSysteme
self.data_errors.push(obj)

            // FIND INDEX FROM ID
            var indexStud = self.data_students_file.findIndex(x => (x.tran_tran_ID == tranID));
            // ---- CHECK IF ERROR OR WARNING ....
            var returnOutcome = 'ERROR'
            if (jERR.consequenceTransaction == 'A') {returnOutcome = 'DONE'}
            // MARK PROCESSED :: FOR UPDATING NON ERRORS
            self.data_students_file[indexStud].processed = 1

switch(self.data_students_file[0].fileTran_TYPE) {

// -----------------------------------------------------------------
    case 'IPR':
            queryMaster += `UPDATE myMEQ_STUDENT_IPR SET ipr_status = '` + returnOutcome + `', ipr_message = '` + jERR.descriptionMessageTransactionSysteme.replace(/'/g,"''") + `' WHERE (ipr_id = '` + self.data_students_file[indexStud].tran_tran_ID + `') ;` 
    break;
// -----------------------------------------------------------------


// -----------------------------------------------------------------
    case 'ICR':
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET icr_status = '` + returnOutcome + `', icr_message = '` + jERR.descriptionMessageTransactionSysteme.replace(/'/g,"''") + `' WHERE (icr_id = '` + self.data_students_file[indexStud].tran_tran_ID + `') ;` 
    break;
// -----------------------------------------------------------------


// -----------------------------------------------------------------
    case 'RCS':
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET rcs_status = '` + returnOutcome + `', rcs_message = '` + jERR.descriptionMessageTransactionSysteme.replace(/'/g,"''") + `' WHERE (rcs_id = '` + self.data_students_file[indexStud].tran_tran_ID + `') ;` 
    break;
// -----------------------------------------------------------------


// -----------------------------------------------------------------
    case 'CNS':
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET cns_status = '` + returnOutcome + `', cns_message = '` + jERR.descriptionMessageTransactionSysteme.replace(/'/g,"''") + `' WHERE (cns_id = '` + self.data_students_file[indexStud].tran_tran_ID + `') ;` 
    break;
// -----------------------------------------------------------------

  default:
    // code block
} 



            }
            
        }

// GIVE IT A SECOND ....

setTimeout(() => {  






setTimeout(() => { 

// console.log('LAST')

// NUMBER SENT
    self.file_message_2 = "ERRORS : " + self.errorCount


// RUN THE QUERY FROM ABOVE
// console.log(queryMaster)

axios({
    method: 'post',
    url: self.$url+sessionStorage.getItem('url_query_form'),
    data: {query:encodeURIComponent(queryMaster)},
})
.then(res => {
    self.isLoading = false;
// UPDATE MASTER FILE (_FILE_TRAN)
    var query = `UPDATE myMEQ_FILE_TRAN SET fileTran_STATUS = 'ACCEPT' WHERE (fileTran_ID = ` + fileID + `)`
    console.log(query)
    axios.get(self.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        //document.querySelector('#myModalFilesPending').classList.remove('is-active');
        //self.sort_this_shit()
    })
})   


}, 400);

// console.log('FIRST')
// CHECK FOR NON-ERRORS
var qStuds = ``
switch(self.data_students_file[0].fileTran_TYPE) {

// -----------------------------------------------------------------
  case 'IPR':
        for (var x = 0; x < self.data_students_file.length; x++) {
            if (self.data_students_file[x].processed == 0) {qStuds += ` (ipr_id = '` + self.data_students_file[x].tran_tran_ID + `') OR `}
        }
        if (qStuds != '') {
            qStuds = qStuds.substring(0, qStuds.length-3); // REMOVE LAST -OR-
            queryMaster += `UPDATE myMEQ_STUDENT_IPR SET ipr_status = 'DONE' WHERE ` + qStuds +';'
        }
    break;
// -----------------------------------------------------------------

// -----------------------------------------------------------------
  case 'ICR':
        for (var x = 0; x < self.data_students_file.length; x++) {
            if (self.data_students_file[x].processed == 0) {qStuds += ` (icr_id = '` + self.data_students_file[x].tran_tran_ID + `') OR `}
        }
        if (qStuds != '') {
            qStuds = qStuds.substring(0, qStuds.length-3); // REMOVE LAST -OR-
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET icr_status = 'DONE' WHERE ` + qStuds +';'
        }

    break;
// -----------------------------------------------------------------

// -----------------------------------------------------------------
  case 'RCS':
        for (var x = 0; x < self.data_students_file.length; x++) {
            if (self.data_students_file[x].processed == 0) {qStuds += ` (rcs_id = '` + self.data_students_file[x].tran_tran_ID + `') OR `}
        }
        if (qStuds != '') {
            qStuds = qStuds.substring(0, qStuds.length-3); // REMOVE LAST -OR-
            queryMaster += `UPDATE MyMEQ_COURSESTUDENT SET rcs_status = 'DONE' WHERE ` + qStuds +';'
        }

    break;
// -----------------------------------------------------------------


  default:
    // code block
} 


}, 400);


      }); // END AXIOS

      }); // END XML >> JS

// }); // END AXIOS


},
isArray:function(what) {
    return Object.prototype.toString.call(what) === '[object Array]';
},





load_students_page:function(st,en) {

console.log(st + ' - ' + en)


    this.data_students_page = []
    for (var i = st; i <= en; i++) {
      if (this.data_students_show[i]) { this.data_students_page.push(this.data_students_show[i]) }
    }

},


set_pagination:function() {
    this.display_total = this.data_students_show.length
    this.display_offset = 0
    if (this.display_max > this.display_total) {
        this.display_string = '1-' + this.display_total + ' of ' + this.display_total
    } else {
        this.display_string = '1-' + this.display_max + ' of ' + this.display_total
    }
    this.load_students_page(0,Number(this.display_max)-1)

}, // END PAGINATION CHECK
pagination_next:function() {
    if ((Number(this.display_offset)+Number(this.display_max)) > this.display_total) {return}
    this.display_offset = Number(this.display_offset) + Number(this.display_max)

    // CHECK IF LAST
    if ((Number(this.display_offset)+Number(this.display_max)) > this.display_total) {
        this.display_string = (Number(this.display_offset) + 1) + '-' + this.display_total  + ' of ' + this.display_total
        this.load_students_page(Number(this.display_offset) + 1,Number(this.display_total)-1)
    } else {
        this.display_string = (Number(this.display_offset) + 1) + '-' + (Number(this.display_offset)+Number(this.display_max))  + ' of ' + this.display_total
        this.load_students_page(Number(this.display_offset) + 1,(Number(this.display_offset)+Number(this.display_max)))
    }

    
},
pagination_previous:function() {
    if (this.display_offset == 0) {return}
    this.display_offset = Number(this.display_offset) - Number(this.display_max)
    this.display_string = (Number(this.display_offset)+1) + '-' + (Number(this.display_offset)+Number(this.display_max))  + ' of ' + this.display_total

    this.load_students_page(Number(this.display_offset)+1,(Number(this.display_offset)+Number(this.display_max)))
},


session_annee_next:function() {
    if (this.grp_sess == 'H') {
        this.grp_sess = 'E' ; this.dt_sess_start = "20"+this.grp_ann+"-05-01" ; this.dt_sess_end = "20"+this.grp_ann+"-08-31"
    }
    else if (this.grp_sess == 'E') {
        this.grp_sess = 'A' ; this.dt_sess_start = "20"+this.grp_ann+"-09-01" ; this.dt_sess_end = "20"+this.grp_ann+"-12-31"
    }
    else {
        this.grp_ann = parseInt(this.grp_ann) + 1
        this.grp_sess = 'H' ; this.dt_sess_start = "20"+this.grp_ann+"-01-01" ; this.dt_sess_end = "20"+this.grp_ann+"-04-30"
    }
    this.session_annee_change()
},
session_annee_previous:function() {
    if (this.grp_sess == 'H') {
        this.grp_ann = parseInt(this.grp_ann) - 1
        this.grp_sess = 'A' ; this.dt_sess_start = "20"+this.grp_ann+"-09-01" ; this.dt_sess_end = "20"+this.grp_ann+"-12-31"
    }
    else if (this.grp_sess == 'E') {
        this.grp_sess = 'H' ; this.dt_sess_start = "20"+this.grp_ann+"-01-01" ; this.dt_sess_end = "20"+this.grp_ann+"-04-30"
    }
    else {
        this.grp_sess = 'E' ; this.dt_sess_start = "20"+this.grp_ann+"-05-01" ; this.dt_sess_end = "20"+this.grp_ann+"-08-31"
    }
    this.session_annee_change()
},



return_style_selected:function(val) {
// hl THE CURRENTLY SELECTED
    if (this.transmission_type == val) {return 'has-background-primary-light has-text-black'}
    else {return 'has-background-white has-text-black'}

},

process_select_all() {
// SELECT ALL BUTTON

var op = 'C' // DEFAULT IS CREATE
if (this.transmission_status_selected == 'DONE') {op = 'A'}


for ( var i = 0; i < this.data_students_show.length; i++ ) { 
if (this.data_students_show[i].hasErrors == '') {
        var tranID = this.transmission_type + this.randomTran_ID()

        this.data_toTransmit.push({ 
            data : this.data_students_show[i],tranTYPE : this.transmission_type, operation : op, id : tranID
        });
     
        switch(op) {// UPDATE TOTALS
            case "C":this.cnt_add += 1;break;
            case "M":this.cnt_mod += 1;break;
            case "A":this.cnt_del += 1;break;
        }
     
}  // END CHECKING NO ERRORS  
} // END-LOOP
    this.cnt_total = Number(this.cnt_add) + Number(this.cnt_mod) + Number(this.cnt_del)
},





click_did_todo:function() {
    this.data_students_show = []
    this.transmission_type = 'DID'
    this.transmission_status_selected = 'NEED'
    for ( var i = 0; i < this.data_students_did.length; i++ ) { 
        this.data_students_did[i].hasErrors = '' // RESET ERRORS
        if (!this.data_students_did[i].did_status) { this.data_students_show.push(this.validate_data(this.data_students_did[i])) ; }
    }
    this.set_pagination()
},
click_did:function(showWhat) {
    this.data_students_show = []
    this.transmission_type = 'DID'
    this.transmission_status_selected = showWhat
    for ( var i = 0; i < this.data_students_did.length; i++ ) { 
        if (this.data_students_did[i].did_status == showWhat) { this.data_students_show.push(this.data_students_did[i]) ; }
    }  
    this.set_pagination()
},


click_ipr_todo:function() {
    this.data_students_show = []
    this.transmission_type = 'IPR'
    this.isLoading=true;
    this.transmission_status_selected = 'NEED'
    //  // CHECK IN IPR ARRAY
    this.isLoading=true;
setTimeout(() => {    
    for ( var i = 0; i < this.data_students_unique.length; i++ ) { 
        this.data_students_unique[i].hasErrors = '' // RESET ERRORS 
        var iX = this.data_students_ipr.findIndex(x => (x.student_ID == this.data_students_unique[i].studID));
        if(iX == -1){ this.data_students_show.push(this.validate_data(this.data_students_unique[i])) ; } //END IF
    }
     this.isLoading = false; this.set_pagination() }, 500); // END
},
// 




click_ipr:function(showWhat) {
    this.data_students_show = []
    this.data_students_page = []

    this.transmission_type = 'IPR'
    this.transmission_status_selected = showWhat
    for ( var i = 0; i < this.data_students_ipr.length; i++ ) { 
        if (this.data_students_ipr[i].ipr_status == showWhat) { 
            var iX = this.data_students_unique.findIndex(x => (x.studID == this.data_students_ipr[i].student_ID));
            
            if (iX > -1) {
                this.data_students_unique[iX].ipr_message = this.data_students_ipr[i].ipr_message
                this.data_students_page.push(this.data_students_unique[iX]) 
                this.data_students_show.push(this.data_students_unique[iX]) ; 
            } }
    }  
    this.set_pagination()
},

click_icr_todo:function() {
    this.data_students_show = []
    this.transmission_type = 'ICR'
    this.isLoading=true;
    this.transmission_status_selected = 'NEED'
    setTimeout(() => { 
    for ( var i = 0; i < this.data_students_all.length; i++ ) { 
        this.data_students_all[i].hasErrors = '' // RESET ERRORS
        if (!this.data_students_all[i].icr_status) {this.data_students_show.push(this.validate_data(this.data_students_all[i])) ;}
    }  
     this.isLoading = false; this.set_pagination()}, 500); // END
},
click_icr:function(showWhat) {
    this.data_students_show = []
    this.transmission_type = 'ICR'
    this.transmission_status_selected = showWhat
    for ( var i = 0; i < this.data_students_all.length; i++ ) { 
        if (this.data_students_all[i].icr_status == showWhat) {this.data_students_show.push(this.data_students_all[i]) ;}
    }  
    this.set_pagination()
},
click_rcs_todo:function() {
    this.data_students_show = []
    this.transmission_type = 'RCS'
    this.isLoading=true;
    this.transmission_status_selected = 'NEED'
    setTimeout(() => { 
    for ( var i = 0; i < this.data_students_all.length; i++ ) { 
        this.data_students_all[i].hasErrors = '' // RESET ERRORS
        if (!this.data_students_all[i].rcs_status) 
        {this.data_students_show.push(this.validate_data(this.data_students_all[i])) ;}
    } 
     this.isLoading = false; this.set_pagination() }, 500); // END 
},
click_rcs:function(showWhat) {
    this.data_students_show = []
    this.transmission_type = 'RCS'
    this.transmission_status_selected = showWhat
    for ( var i = 0; i < this.data_students_all.length; i++ ) { 
        if (this.data_students_all[i].rcs_status == showWhat) {this.data_students_show.push(this.data_students_all[i]) ;}
    }  
    this.set_pagination()
},
click_cns_todo:function() {
    this.data_students_show = []
    this.transmission_type = 'CNS'
    this.transmission_status_selected = 'NEED'
    this.isLoading=true;
    setTimeout(() => { 
    for ( var i = 0; i < this.data_students_all.length; i++ ) { 
        this.data_students_all[i].hasErrors = '' // RESET ERRORS
        if (!this.data_students_all[i].cns_status && this.data_students_all[i].cs_REMARK == 'EQ') {this.data_students_show.push(this.validate_data(this.data_students_all[i])) ;}
    } 
     this.isLoading = false; this.set_pagination() }, 500); // END 


    // for ( var i = 0; i < this.data_students_all.length; i++ ) { 
    //     if (!this.data_students_all[i].cns_status) {this.data_students_show.push(this.data_students_all[i]) ;}
    // }  
    // this.set_pagination()
},
click_cns:function(showWhat) {
    this.data_students_show = [] 
    this.transmission_type = 'CNS'
    this.transmission_status_selected = showWhat
    for ( var i = 0; i < this.data_students_all.length; i++ ) { 
        if (this.data_students_all[i].cns_status == showWhat && this.data_students_all[i].cs_REMARK == 'EQ') {this.data_students_show.push(this.data_students_all[i]) ;}
    }  
    this.set_pagination()
},


sort_search:function() {
    if (this.search == '') {return}
    this.sort_this_shit()
},

clear_search_search:function() {
    if (this.search == '') {return}
    this.search = ''
    this.sort_this_shit()
},
clear_search_group:function() {
    if (this.data_menu_group_selected == '') {return}
    this.data_menu_group_selected = ''
    this.sort_this_shit()
},
clear_search_cour:function() {
    if (this.data_menu_course_selected == '') {return}
    this.data_menu_course_selected = ''
    this.sort_this_shit()
},


// CHECK IF THE TRAN ALREADY SELECTED
check_tran_selected:function(sID,gID,tran) {

    for ( var i = 0; i < this.data_toTransmit.length; i++ ) { 

        if (this.data_toTransmit[i].data.studID == sID && this.data_toTransmit[i].data.group_ID == gID && this.data_toTransmit[i].tranTYPE == tran) 
        //if (this.data_toTransmit[i].tranTYPE == tran) 
        {console.log('--check--YES' ) ; return true  }
    }
    console.log('--check--NONONON' )
    return false 

},
// END CHECKING IF SELECTED



sort_this_shit:function(clearShit) {
this.isLoading = true;



this.data_did={cnt:0,done:0,todo:0,error:0,pending:0}
this.data_ipr={cnt:0,done:0,todo:0,error:0,pending:0}
this.data_icr={cnt:0,done:0,todo:0,error:0,pending:0}
this.data_rcs={cnt:0,done:0,todo:0,error:0,pending:0}
this.data_cns={cnt:0,done:0,todo:0,error:0,pending:0}

// this.data_pie_did=[]
// this.data_pie_ipr=[]
// this.data_pie_icr=[]
// this.data_pie_rcs=[]
// this.data_pie_cns=[]

this.data_toTransmit=[] // HOLDS THE STUDENTS TO SEND
this.data_confirm=[] // HOLDS DATA TO CONFIRM SEnD

this.data_students_show=[]
this.data_students_unique=[]
this.data_students_page = []
this.data_students_did =[]
this.data_students_ipr =[]

this.transmission_type = ''

  var sqlGroup = '' ; var sqlGroupStud = '' ;var sqlCour = '' ; 
  var sWHERE = '' // SEARCH
    if (this.search) { sWHERE =  `AND ((student_lNAME LIKE '` + this.search + `%25') OR (student_GRPCODE LIKE '` + this.search + `%25'))` }
    if (this.data_menu_group_selected != '') { sqlGroupStud = " AND student_GRPCODE = '" + this.data_menu_group_selected + "' " ; sqlGroup = " AND group_CODE = '" + this.data_menu_group_selected + "' " }
    if (this.data_menu_course_selected != '') { sqlCour = " AND cour_CODE = '" + this.data_menu_course_selected + "' " }


// GET DID STUDENTS --> BASED ON START DATE -- NOT SEMEsTERS
var query = `SELECT MyMEQ_STUDENT.student_ID AS studID, MyMEQ_STUDENT.student_lNAME,student_GRPCODE, student_fNAME, student_CodePerm
,FORMAT(student_CreateDate,'yyyy-MM-dd') AS student_CreateDate,student_NumAdmission
, MyMEQ_STUDENT.did_status, MyMEQ_STUDENT.did_message, MyMEQ_STUDENT.adr_status, MyMEQ_STUDENT.adr_message, MyMEQ_STUDENT.cit_status, MyMEQ_STUDENT.cit_message
, student_rueNUM, student_Address, student_apt, student_City, student_Province, student_Country, student_Postal, student_TelHome
, myMEQ_STUDENT_TRANSMISSION.*
FROM MyMEQ_STUDENT INNER JOIN myMEQ_STUDENT_TRANSMISSION ON MyMEQ_STUDENT.student_ID = myMEQ_STUDENT_TRANSMISSION.student_ID
WHERE (student_CreateDate BETWEEN '` + this.dt_sess_start + `' AND '` + this.dt_sess_end + `') ` + sWHERE + sqlGroupStud +  ` ORDER BY  MyMEQ_STUDENT.student_lNAME` 
console.log(query)
console.log('--------------------------------------------------------------')
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    this.data_students_did = res.data


// GET ALL STUDENTS -- THIS GETS THE INFO FOR ICR/RCS/CNS ALSO
var query = `SELECT MyMEQ_STUDENT.student_ID AS studID, MyMEQ_STUDENT.student_lNAME, 
Replace(MyMEQ_COURSESTUDENT.cs_MARK,'null','') AS cs_MARK, Replace(MyMEQ_COURSESTUDENT.cs_REMARK,'null','') AS cs_REMARK, 
MyMEQ_COURSESTUDENT.group_ID
,student_GRPCODE, student_fNAME, student_CodePerm
,FORMAT(student_CreateDate,'yyyy-MM-dd') AS student_CreateDate,student_NumAdmission, Replace(group_AVG,'null','') AS group_AVG 
, MyMEQ_COURSESTUDENT.icr_status, MyMEQ_COURSESTUDENT.icr_message, MyMEQ_COURSESTUDENT.rcs_status, MyMEQ_COURSESTUDENT.rcs_message, 
MyMEQ_COURSESTUDENT.cns_status, MyMEQ_COURSESTUDENT.cns_message, 
MyMEQ_STUDENT.did_status, MyMEQ_STUDENT.did_message, MyMEQ_STUDENT.adr_status, MyMEQ_STUDENT.adr_message, MyMEQ_STUDENT.cit_status, MyMEQ_STUDENT.cit_message
, MyMEQ_COUR.cour_CODE, MyMEQ_COUR.cour_TITRE_F, MyMEQ_COUR.cour_TITRE_E
, MyMEQ_COURSESTUDENT.cs_ID, MyMEQ_PROGRAM.prog_CODE, MyMEQ_PROGRAM.prog_YEAR , myMEQ_STUDENT_TRANSMISSION.*
, '' AS hasErrors, '' AS ipr_message
FROM MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID 
INNER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID 
INNER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID 
INNER JOIN myMEQ_STUDENT_TRANSMISSION ON MyMEQ_STUDENT.student_ID = myMEQ_STUDENT_TRANSMISSION.student_ID
INNER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID
WHERE (MyMEQ_GROUP.group_SESS = '` + this.grp_sess + `') AND  (MyMEQ_GROUP.group_ANN = '` + this.grp_ann + `') 
` + sWHERE + sqlGroup + sqlCour + ` ORDER BY  MyMEQ_STUDENT.student_lNAME`

console.log('XXXX')
console.log(query)

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
    this.data_students_all = res.data



if (this.data_students_all.length > 0) {
// GET DISTINCT GROUPS !
    if (this.data_menu_group_selected == '') {this.data_menu_groups = [...new Set(this.data_students_all.map(item => item.student_GRPCODE))];}
    // GET DISTINCT COURSES !
    if (this.data_menu_course_selected == '') {this.data_menu_courses = [...new Set(this.data_students_all.map(item => item.cour_CODE))];}
}


// SORT STATS -----------------------------------------------------------------
for ( var i = 0; i < this.data_students_all.length; i++ ) {  
if (this.data_students_all[i].group_ID > 0) { // CHECK FOR GROUP
// ICR

if (this.data_students_all[i].cs_REMARK == 'EQ') {this.cnt_tran_cns++}

        this.data_icr.cnt++
        if (!this.data_students_all[i].icr_status) { this.data_icr.todo++ ; }
        else {
                if (this.data_students_all[i].icr_status=='DONE') { this.data_icr.done++ ; }
                else if (this.data_students_all[i].icr_status=='ERROR') { this.data_icr.error++ ; }
                else if (this.data_students_all[i].icr_status=='PENDING') { this.data_icr.pending++ ; }
                else {this.data_icr.todo++ ;}
            }
// RCS
        this.data_rcs.cnt++
        if (!this.data_students_all[i].rcs_status) { this.data_rcs.todo++ ; }
        else {
                if (this.data_students_all[i].rcs_status=='DONE') { this.data_rcs.done++ ; }
                else if (this.data_students_all[i].rcs_status=='ERROR') { this.data_rcs.error++ ; }
                else if (this.data_students_all[i].rcs_status=='PENDING') { this.data_rcs.pending++ ; }
                else {this.data_rcs.done++ ;}
            }
// CHECK COUR NON SUIVI
    if (this.data_students_all[i].cs_REMARK == 'EQ') {
console.log('YUP : EQ')
        this.data_cns.cnt++
        if (!this.data_students_all[i].cns_status) { this.data_cns.todo++ ; }
        else {
                if (this.data_students_all[i].cns_status=='DONE') { this.data_cns.done++ ; }
                else if (this.data_students_all[i].cns_status=='ERROR') { this.data_cns.error++ ; }
                else if (this.data_students_all[i].cns_status=='PENDING') { this.data_cns.pending++ ; }
                else {this.data_cns.todo++ ;}
            }
    } // END CHECKING CNS

// this.data_pie_icr = this.load_pie(this.data_icr)
// this.data_pie_rcs = this.load_pie(this.data_rcs)
// this.data_pie_cns = this.load_pie(this.data_cns)


} } // END FOR -- IF 
this.data_pie_icr = this.load_pie(this.data_icr)
this.data_pie_rcs = this.load_pie(this.data_rcs)
this.data_pie_cns = this.load_pie(this.data_cns)







// . GET UNIQUE WHOLE ROW ---------------------------------
// this.data_students_unique = Array.from(new Set(data.map((item => item.this.data_students_all))))


// GET UNIQUE STUDENTS FOR DID.../IPR
for ( var looper = 0; looper < this.data_students_all.length; looper++ ) {    
    var i = this.data_students_unique.findIndex(x => (x.studID == this.data_students_all[looper].studID));
    if(i == -1){ this.data_students_unique.push(this.data_students_all[looper]) } //END IF
} // END FOR



var query = `SELECT * FROM  myMEQ_STUDENT_IPR 
WHERE sess = '` + this.grp_sess  + `'  AND ann = '` + this.grp_ann  + `'`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
this.data_students_ipr = res.data

// alert(this.data_students_unique.length)
// alert( this.grp_ann+this.grp_sess)
// SORT STATS -----------------------------------------------------------------

setTimeout(() => { this.do_stats_ipr(); this.do_stats_did(); this.isLoading = false;}, 400);



});  });  });


},

do_stats_did:function() {

    for ( var ib = 0; ib < this.data_students_did.length; ib++ ) {

        this.data_did.cnt++
        if (!this.data_students_did[ib].did_status) { this.data_did.todo++ ; }
        else {
                if (this.data_students_did[ib].did_status=='DONE') { this.data_did.done++ ; }
                else if (this.data_students_did[ib].did_status=='ERROR') { this.data_did.error++ ; }
                else if (this.data_students_did[ib].did_status=='PENDING') { this.data_did.pending++ ; }
                else {this.data_did.todo++ ;}
        }
    }
    this.data_pie_did = this.load_pie(this.data_did)

}, // END STATS DID

do_stats_ipr:function() {

for ( var ib = 0; ib < this.data_students_unique.length; ib++ ) { 

//     var sessann = moment(this.data_students_unique[ib].student_CreateDate).format('YY')
//     var mois = moment(this.data_students_unique[ib].student_CreateDate).format('M')
//     if ( mois <= 4)  { sessann += 'H'} else if ( mois <= 8) { sessann += 'E'} else { sessann += 'A'}
// // // // CHECK DID
//     if (sessann == this.grp_ann + this.grp_sess) {

// // PUSH INTO DID ARRAY FOR DISPLAY
// this.data_students_did.push(this.data_students_unique[ib])

//         this.data_did.cnt++
//         if (!this.data_students_unique[ib].did_status) { this.data_did.todo++ ; }
//         else {
//                 if (this.data_students_unique[ib].did_status=='DONE') { this.data_did.done++ ; }
//                 else if (this.data_students_unique[ib].did_status=='ERROR') { this.data_did.error++ ; }
//                 else if (this.data_students_unique[ib].did_status=='PENDING') { this.data_did.pending++ ; }
//                 else {}
//             }
//     } // END CHECKING IF DID

    this.data_ipr.cnt++
//  // CHECK IN IPR ARRAY
    var self = this;
    var iX = this.data_students_ipr.findIndex(x => (x.student_ID == self.data_students_unique[ib].studID));
    if(iX == -1){ this.data_ipr.todo++ ; 
        // PUT IN ARRAY FOR DISPLAY
        // this.data_students_ipr.push(self.data_students_unique[ib])
    } //END IF
    else { 
        if (this.data_students_ipr[iX].ipr_status=='DONE') { this.data_ipr.done++ ; }
        else if (this.data_students_ipr[iX].ipr_status=='ERROR') { this.data_ipr.error++ ; }
        else if (this.data_students_ipr[iX].ipr_status=='PENDING') { this.data_ipr.pending++ ; }
        else {this.data_ipr.todo++ ;}
     }
} // END FOR MAIN
this.data_pie_ipr = this.load_pie(this.data_ipr)

}, // END STATS IPR ....






sort_shit_start:function() {
    // this.isLoading=true;
    this.doSynchronousLoop(this.data_students_unique,this.sort_shit_ipr, this.sort_shit_ipr_end)


    // this.doSynchronousLoop(this.data_students_all,this.sort_shit_sort_icr, this.sort_shit_icr_end)
    // this.doSynchronousLoop(this.data_students_all,this.sort_shit_sort_rcs, this.sort_shit_rcs_end)
    
},

sort_shit_ipr:function(item, i, callback) {
       
this.isLoading=true;
// CHECK DID -- START DATE IN THIS SESS/ANN
var sessann = moment(item.student_CreateDate).format('YY')
if (moment(item.student_CreateDate).format('M') < 5)  { sessann += 'H'} else if (moment(item.student_CreateDate).format('M') < 8) { sessann += 'E'} else { sessann += 'A'}


// CHECK DID
    if (sessann == this.grp_ann+this.grp_sess) {
        this.data_did.cnt++
        if (!item.did_status) { this.data_did.todo++ ; }
        else {
                if (item.did_status=='DONE') { this.data_did.done++ ; }
                else if (item.did_status=='ERROR') { this.data_did.error++ ; }
                else if (item.did_status=='PENDING') { this.data_did.pending++ ; }
                else {}
            }
    } // END CHECKING IF DID


    this.data_ipr.cnt++
    // CHECK IN IPR ARRAY
    var i = this.data_students_ipr.findIndex(x => (x.student_ID == item.studID));
    if(i == -1){ this.data_ipr.todo++ ; } //END IF
    else { this.data_ipr.done++ ; }


this.data_pie_did = this.load_pie(this.data_did)
this.data_pie_ipr = this.load_pie(this.data_ipr)

    callback() 
},
sort_shit_ipr_end:function() {
    this.isLoading=false;
    this.data_pie_did = this.load_pie(this.data_did)
    this.data_pie_ipr = this.load_pie(this.data_ipr)

}, // END IPR END


sort_shit_sort_icr:function(item, i, callback) {
    this.isLoading=true;
if (item.group_ID > 0) {

        this.data_icr.cnt++
        if (!item.icr_status) { this.data_icr.todo++ ; }
        else {
                if (item.icr_status=='DONE') { this.data_icr.done++ ; }
                else if (item.icr_status=='ERROR') { this.data_icr.error++ ; }
                else if (item.icr_status=='PENDING') { this.data_icr.pending++ ; }
                else {}
            }


    //ICR
    //     this.data_icr.cnt++
    //     var arr_filter = this.data_files.filter((data) => data.student_ID == item.studID && data.group_ID == item.group_ID && data.tran_TYPE == 'ICR')
    //     if (arr_filter.length == 0 ) {this.data_icr.todo++ ; }
    //     else {
    // console.log(arr_filter[0].fileTran_STATUS)
    //         if (arr_filter[0].fileTran_STATUS == 'ACCEPT')  {this.data_icr.done++ ; }
    //         else if (arr_filter[0].fileTran_STATUS == 'PENDING')  {this.data_icr.pending++ ;}
    //         else if (+arr_filter[0].tran_bERROR == true)  {this.data_icr.error++ ; }
    //         else {}
    //     }
    
// CHECK COUR NON SUIVI
    if (item.cs_REMARK == 'EQ') {

        this.data_cns.cnt++
        if (!item.cns_status) { this.data_cns.todo++ ; }
        else {
                if (item.cns_status=='DONE') { this.data_cns.done++ ; }
                else if (item.cns_status=='ERROR') { this.data_cns.error++ ; }
                else if (item.cns_status=='PENDING') { this.data_cns.pending++ ; }
                else {}
            }


        // this.data_cns.cnt++
        // var arr_filter = this.data_files.filter((data) => data.student_ID == item.studID && data.group_ID == item.group_ID && data.tran_TYPE == 'CNS')
        // if (arr_filter.length == 0 ) {this.data_cns.todo++ ; }
        // else {
        //     if (arr_filter[0].fileTran_STATUS == 'ACCEPT')  {this.data_cns.done++ ; }
        //     else if (arr_filter[0].fileTran_STATUS == 'PENDING')  {this.data_cns.pending++ ;}
        //     else if (+arr_filter[0].tran_bERROR == true)  {this.data_cns.error++ ; }
        //     else {}
        // }
    } // END CHECKING EQ (CNS)
} // END CHECKING GROUP

this.data_pie_icr = this.load_pie(this.data_icr)
this.data_pie_cns = this.load_pie(this.data_cns)
    callback()

},
sort_shit_icr_end:function() {
// ---- PIE ICR
    this.isLoading=false;
    this.data_pie_icr = this.load_pie(this.data_icr)
    this.data_pie_cns = this.load_pie(this.data_cns)
}, // END ICR / CNS

sort_shit_sort_rcs:function(item, i, callback) {
this.isLoading=true;
if (item.group_ID > 0) {
// RCS
    this.data_rcs.cnt++
    var arr_filter = this.data_files.filter((data) => data.student_ID == item.studID && data.group_ID == item.group_ID && data.tran_TYPE == 'RCS')
    if (arr_filter.length == 0 ) {this.data_rcs.todo++ ; }
    else {
        if (arr_filter[0].fileTran_STATUS == 'ACCEPT')  {this.data_rcs.done++ ; }
        else if (arr_filter[0].fileTran_STATUS == 'PENDING')  {this.data_rcs.pending++ ;}
        else if (+arr_filter[0].tran_bERROR == true)  {this.data_rcs.error++ ; }
        else {}
    } 
} // END IF CHECK

this.data_pie_rcs = this.load_pie(this.data_rcs)
callback()

},
sort_shit_rcs_end:function() { 
// ---- PIE RCD
    this.isLoading=false;
    this.data_pie_rcs = this.load_pie(this.data_rcs)
},


// LOAD PIE DATA !!!!
load_pie:function(arrPIE) {

    var data_collection =  null;
    data_collection = {
        labels: ['DONE','TO DO','ERROR', 'PENDING'],
        datasets: [{
                backgroundColor: ["#23d160","#209cee", "#ff3860", "#ffdd57"],
                data: [arrPIE.done,arrPIE.todo,arrPIE.error,arrPIE.pending]}]
    }
    return data_collection

}, // END LOAD PIE




modal_cancel_tran:function() {
    this.data_toTransmit=[] // HOLDS THE STUDENTS TO SEND
    this.data_confirm=[] // HOLDS DATA TO CONFIRM SEnD
    this.cnt_add=0
    this.cnt_mod=0
    this.cnt_del=0
    this.cnt_total=0
    this.cnt=0
    document.querySelector('#myModalTransmission').classList.remove('is-active');
},

modal_close:function() {
    document.querySelector('#myModalTransmission').classList.remove('is-active');
},


modal_close_files:function() {
    document.querySelector('#myModalFilesPending').classList.remove('is-active');
},
modal_show_files:function() {
    this.isLoading=true
    var query =  "SELECT *, '' AS fileFTP_CON,'' AS fileFTP_DET,0 AS fileShow,0 AS fileConfirm, 0 AS fileDetail FROM myMEQ_FILE_TRAN WHERE fileTran_STATUS = 'PENDING' ORDER BY fileTran_DATE ASC"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_files_pending = res.data
        document.querySelector('#myModalFilesPending').classList.add('is-active');
        // this.isLoading=false
        setTimeout(() => { this.check_files_ftp() }, 100);
    });
},


// GENERATE ID FOR TRANSACTION -- SAVE TO DB (NEW) 
    randomTran_ID:function() {
    return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });},

emit_tran_add:function(data, tranTYPE, operation, tranID) {
// MASTER EMIT !!
        this.data_toTransmit.push({ 
            data : data,tranTYPE : tranTYPE, operation : operation, id : tranID
        });
      
// UPDATE TOTALS
    switch(operation) {
        case "C":
            this.cnt_add += 1;break;
        case "M":
            this.cnt_mod += 1;break;
        case "A":
            this.cnt_del += 1;break;
    }
    this.cnt_total = Number(this.cnt_add) + Number(this.cnt_mod) + Number(this.cnt_del) 
  
},
emit_tran_remove:function(tranID) {
// MASTER EMIT REMOVE
        var i = 0 ; var self = this
        this.data_toTransmit.forEach(function(item){ 
            if (item.id == tranID)
            {             
            switch(item.operation) {
                case "C":
                    self.cnt_add -= 1;break;
                case "M":
                    self.cnt_mod -= 1;break;
                case "A":
                    self.cnt_del -= 1;break;
            }
            self.data_toTransmit.splice(i,1) ; return}

            else { i++ }
        })
},





create_files_confirm:function() {
// SHOW SUMMARY -- AND CONFIRM 

this.isLoading=true;
this.data_confirm=[]
//' GET UNIQUE TRANs'

var arrU = [...new Set(this.data_toTransmit.map(item => item.tranTYPE))];
// 3. SORT BY DATE
arrU.sort((a,b) => (a.tranTYPE > b.tranTYPE) ? 1 : ((b.tranTYPE > a.tranTYPE) ? -1 : 0))

console.log(arrU)
for (var i = 0; i < arrU.length; i++) {
var cC=0;var cM=0;var cA=0; 
for (var x = 0; x < this.data_toTransmit.length; x++) {  

// alert(this.data_toTransmit[x].tranTYPE)

if (this.data_toTransmit[x].tranTYPE == arrU[i]) {

    if (this.data_toTransmit[x].operation == 'C') {cC++}
    if (this.data_toTransmit[x].operation == 'M') {cM++}
    if (this.data_toTransmit[x].operation == 'A') {cA++}

} // END IF
} // END TRAN LOOP 



    var obj = {
        tran_type: arrU[i],
        tran_c : cC,
        tran_m : cM,
        tran_a : cA,
        note : ''
    }
    this.data_confirm.push(obj)
} // END UNIQUE LOOP 
    // SHOW

setTimeout(() => { this.isLoading=false ; document.querySelector('#myModalTransmission').classList.add('is-active'); }, 500);

   
}, // END CONFIRM



create_files:function() {
  
  // DATA_CONFIRM !
    this.doSynchronousLoop(this.data_confirm,this.create_files_start, this.create_files_end)

},

create_files_end:function() {
    this.modal_close()
    this.sort_this_shit(true)
    console.log('****DONE****')
},


// DO THE FILE  
create_files_start:function(item, i, callback) {

// ****************************** GET !!!!!!!!!!!!!!!!
    var tranTYPE = item.tran_type
   
    
    

 // CREATE FILE NAME
var qFileNum = `Update myMEQ_TRAN_ID_SOCRATE Set tranID_FILE = tranID_FILE + 1 ; SELECT tranID_FILE from myMEQ_TRAN_ID_SOCRATE`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(qFileNum))
.then(res => {
    var num = res.data[0].tranID_FILE
    var fileNAME = tranTYPE + '__' + num

// GET STUDENTS FOR TRANSMISSION
    var data_TRAN_MASTER = []

  this.data_toTransmit.forEach(async item => {
        if (item.tranTYPE == tranTYPE) {data_TRAN_MASTER.push(item)}
  })


// GET SESS/ANN 
var sessann  = '20'+this.grp_ann+this.grp_sess
// COLLEGE CODE
var collegeCode = sessionStorage.getItem('college_code')


// CREATE XML FOR TRAN TYPE ----- 
var xmlDATA_RAW = js_transmit.create_transmission_file(collegeCode , sessann, data_TRAN_MASTER, tranTYPE, this.session_ipr) ; 
var xmlDATA = xmlDATA_RAW.normalize('NFD').replace(/[\u0300-\u036f]/g, "")


console.log(xmlDATA)
// return

// GET TRAN NOTE
var note = item.note
if (note != '') {note = note.replace(/'/g,"''")}


// INSERT INTO MASTER TABLE
var query = `INSERT INTO myMEQ_FILE_TRAN (fileTran_FILE,fileTran_SESS,fileTran_ANN,fileTran_NUM_SENT,fileTran_STATUS, fileTran_DATE, fileTran_TYPE, fileTran_COMMENTS,fileTran_FILE_ACTUAL) VALUES ('` + num + `','` + this.grp_sess  + `','` + this.grp_ann + `',` + data_TRAN_MASTER.length + `,'PENDING','`+ moment().format('YYYY-MM-DD HH:mm:ss') + `','` + tranTYPE + `','` + note +`','` + fileNAME +`')`  
// GET NEXT ID
query += `; SELECT MAX(fileTran_ID) AS newID FROM myMEQ_FILE_TRAN`


axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => {
   var fileID = res.data[0].newID 

        // INSERT THE TRANS THEMSELVES ! -- DO IN ONE LONG STRING !
        var query = ``
        for (var i = 0; i < data_TRAN_MASTER.length; i++) {
        var gID = 0 // CHECK IF HAVE GROUP ID
        if (data_TRAN_MASTER[i].data.grpID) { gID = data_TRAN_MASTER[i].data.grpID }


            query += `INSERT INTO myMEQ_TRAN_MASTER (fileTran_ID,student_ID, group_ID, tran_TYPE, tran_tran_ID,tran_SESS,tran_ANN) VALUES (` + fileID + `,` + data_TRAN_MASTER[i].data.studID + `,` + gID + `,'` + data_TRAN_MASTER[i].tranTYPE + `','` + data_TRAN_MASTER[i].id + `','` + this.grp_sess + `','` + this.grp_ann + `')` 
            query += ' ; ' // **** !!!!


// NEW -- NEED TO UPDATE SPOT FOR PARTICULAR TRANS ....
switch(data_TRAN_MASTER[i].tranTYPE) {  
    case "DID": query +=`UPDATE myMEQ_STUDENT SET did_id = '` + data_TRAN_MASTER[i].id + `', did_status='PENDING',did_message='' WHERE student_ID = ` + data_TRAN_MASTER[i].data.studID ; break;
    case "CIT": query +=`UPDATE myMEQ_STUDENT SET cit_id = '` + data_TRAN_MASTER[i].id + `', cit_status='PENDING',cit_message='' WHERE student_ID = ` + data_TRAN_MASTER[i].data.studID ; break;
    case "ADR": query +=`UPDATE myMEQ_STUDENT SET adr_id = '` + data_TRAN_MASTER[i].id + `', adr_status='PENDING',adr_message='' WHERE student_ID = ` + data_TRAN_MASTER[i].data.studID ; break;
    case "IPR": 
        query += `DELETE FROM myMEQ_STUDENT_IPR WHERE student_ID =`+ data_TRAN_MASTER[i].data.studID + ` AND sess = '` + this.grp_sess + `' AND ann = '` + this.grp_ann + `' `;
        query += `;`
        query += `INSERT INTO [myMEQ_STUDENT_IPR]([student_ID],[sess],[ann],[ipr_id],[ipr_status]) VALUES (` + data_TRAN_MASTER[i].data.studID + `,'` + this.grp_sess + `','` + this.grp_ann + `','` + data_TRAN_MASTER[i].id + `','PENDING')`
        break;
    case "ICR": query +=`UPDATE MyMEQ_COURSESTUDENT SET icr_id = '` + data_TRAN_MASTER[i].id + `', icr_status='PENDING',icr_message='' WHERE cs_ID = ` + data_TRAN_MASTER[i].data.cs_ID ; break;
    case "RCS": query +=`UPDATE MyMEQ_COURSESTUDENT SET rcs_id = '` + data_TRAN_MASTER[i].id + `', rcs_status='PENDING',rcs_message='' WHERE cs_ID = ` + data_TRAN_MASTER[i].data.cs_ID ; break;
    case "CNS": query +=`UPDATE MyMEQ_COURSESTUDENT SET cns_id = '` + data_TRAN_MASTER[i].id + `', cns_status='PENDING',cns_message='' WHERE cs_ID = ` + data_TRAN_MASTER[i].data.cs_ID ; break;
}
query += ` ; ` // **** IMPORTANT **** 



        } // end loop insert tran master


console.log(query)


// --------------- THIS WAS GOOD AT ONE POINT !!???    data: formData,
let formData = new FormData();
formData.append('query', encodeURIComponent(query));
// console.log(formData)    headers: {'Content-Type': `multipart/form-data; boundary=${formData._boundary}` },

axios({
    method: 'post',
    url: this.$url+sessionStorage.getItem('url_query_form'),
    data: {
        query:encodeURIComponent(query)
    },
    
})
.then(res => {


    // CREATE XML FILE -- GOOD
    var fileXML = fileNAME + '.xml'
    fileXML = fileNAME + '.SRT'

// check if sysec
    if (this.transmission_type == 'OSA' || this.transmission_type == 'SET')
    {fileXML = fileNAME + '.SEC'}

console.log(' ------------ ---------------- ----------------')
console.log(fileXML)
console.log(' ------------ ---------------- ----------------')
console.log(xmlDATA)






axios({
    method: 'post',
    url: this.$url+'/file_encrypt_II',
    data: {
        ecole:sessionStorage.getItem('college_nickname'),
        filex:encodeURIComponent(fileXML),
        dataxml:encodeURIComponent(xmlDATA)
    },
  
    })
    .then(res => {  
        this.cnt_add=0 ; this.cnt_mod=0
        this.cnt_del=0 ; this.cnt_total=0 ; this.cnt=0
        callback()
        
    })



// 




}); // END INSERT STUDENT


}); // END INSERT MAIN



}) // END GET FILENUM










// ** IPR
// var doIt = this.data_toTransmit.findIndex(x => x.tranTYPE === "IPR");
// if (doIt > -1) 
// {var xmlIPR = js_transmit.create_IPR(collegeCode , sessann, this.data_toTransmit) ; console.log(xmlIPR)}

// // ** ICR
// doIt = this.data_toTransmit.findIndex(x => x.tranTYPE === "ICR");
// if (doIt > -1) 
// {var xmlICR = js_transmit.create_ICR(collegeCode , sessann, this.data_toTransmit) ; console.log(xmlICR)}

// // ** RCS
// doIt = this.data_toTransmit.findIndex(x => x.tranTYPE === "RCS");
// if (doIt > -1) 
// {var xmlRCS = js_transmit.create_RCS(collegeCode , sessann, this.data_toTransmit) ; console.log(xmlRCS)}


},

 

encrypt_it:function() {

axios.post(this.$url+'/encrypt_xml_II')
.then(res => { 
    alert(res)
});




// "@/assets/js/utilities.js";

},




clear_data:function() {
    this.data_transmission = []
    this.data_groups = []
    this.data_students = []
    this.data_students_did = []
    this.data_students_ipr = []
    this.data_students_groups = []

},



session_annee_change:function() {
    this.clear_data();
    this.show_change_session=false

    // SET START/END DATE OF SESS/ANN
    if (this.grp_sess == 'H') {this.dt_sess_start = "20"+this.grp_ann+"-01-01" ; this.dt_sess_end = "20"+this.grp_ann+"-04-30"}
    else if (this.grp_sess == 'E') {this.dt_sess_start = "20"+this.grp_ann+"-05-01" ; this.dt_sess_end = "20"+this.grp_ann+"-08-31"}
    else {this.dt_sess_start = "20"+this.grp_ann+"-09-01" ; this.dt_sess_end = "20"+this.grp_ann+"-12-31"}


    this.sort_this_shit()

},




get_osa_program_change:function() {

this.data_comps = []
this.data_comps_unique = []

var query = `SELECT MyMEQ_COMPETENCE.comp_ID, MyMEQ_COMPETENCE.comp_CODE, MyMEQ_COMPETENCE.comp_TITRE_F, MyMEQ_COMPETENCE.comp_TITRE_E, MyMEQ_RELATION.cour_ID FROM MyMEQ_COMPETENCE INNER JOIN MyMEQ_RELATION ON MyMEQ_COMPETENCE.comp_ID = MyMEQ_RELATION.comp_ID
WHERE prog_ID = ` + this.prog_sysec
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
this.data_comps = res.data

var self = this; 
this.data_comps.forEach(function(item){
    var i = self.data_comps_unique.findIndex(x => x.comp_ID == item.comp_ID);
    if(i <= -1){
        self.data_comps_unique.push(item);  // ({comp_ID: item.comp_ID, comp_TITRE_F: item.comp_TITRE_F});
    }
});
 

//this.data_comps_unique = [...new Set(this.data_comps.map(item => item.comp_ID))];


}) // END AXIOS



},

filter_osa_student:function(compID) {

var arrReturn = []
this.data_comps.forEach(function(item){   
    if (item.comp_ID == compID) 
    {arrReturn.push({cour_ID: item.cour_ID});}
});


var data = this.data_students_osa

data = data.filter(function(item) {
  return !arrReturn.includes(item); 
})

console.log( data)

},


filter_osa_program:function(compID) {
var arrReturn = []
this.data_comps.forEach(function(item){   
    if (item.comp_ID == compID) 
    {arrReturn.push({cour_ID: item.cour_ID});}
});
return arrReturn;
},


get_set:function() {

if (this.prog_sysec == '') 
{alert('Select Program') ; return }


    this.data_students_show = []
    this.data_students_page = []
    this.transmission_type = 'SET'
    this.transmission_status_selected = 'NEED'

// SEARCH ??

// GET DTs
var dt1,dt2
switch  (this.grp_sess) {
    case 'A':
        dt1 = "20" + this.grp_ann + "-09-01"
        dt2 = "20" + this.grp_ann + "-12-31"
        break;
    case 'E':
        dt1 = "20" + this.grp_ann + "-05-01"
        dt2 = "20" + this.grp_ann + "-08-31"
        break;
    case 'H':
        dt1 = "20" + this.grp_ann + "-01-01"
        dt2 = "20" + this.grp_ann + "-04-30"
        break;
}
setTimeout(() => {   
var query = `SELECT  MyMEQ_STUDENT.student_ID,MyMEQ_STUDENT.student_GRPCODE, MyMEQ_STUDENT.student_CodePerm, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_fNAME,  MyMEQ_STUDENT.student_NumAdmission, myMEQ_STUDENT_TRANSMISSION.useLang, MyMEQ_PROGRAM.prog_CODE 
, '' AS hasErrors
FROM MyMEQ_STUDENT INNER JOIN myMEQ_STUDENT_TRANSMISSION ON MyMEQ_STUDENT.student_ID = myMEQ_STUDENT_TRANSMISSION.student_ID 
 INNER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID
WHERE (MyMEQ_STUDENT.student_EndDate BETWEEN '` + dt1 + `' AND '` + dt2 + `') AND (MyMEQ_STUDENT.student_blnActive = 1) AND (MyMEQ_STUDENT.prog_ID = ` + this.prog_sysec + `) AND (MyMEQ_STUDENT.student_blnComplete = 1) ORDER BY MyMEQ_STUDENT.student_lNAME`
console.log(query)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_students_set = res.data
        this.data_students_show = res.data

        this.set_pagination()

    });
}, 200);

}, // END SET

filter_osa_student_comp:function(compCODE) {
    var sessann = this.grp_sess + this.grp_ann

// w. GET ALL COURS FOR COMP
var arrCOURs = []
for ( var i = 0; i < this.data_comps.length ; i++ ) {
    if (this.data_comps[i].comp_CODE == compCODE) {
        arrCOURs.push({cour_ID:this.data_comps[i].cour_ID})
    }
}

var arrReturn = []
for ( var x = 0; x < this.data_students_osa.length ; x++ ) {
    var arrTEMP = []
    for ( i = 0; i < arrCOURs.length ; i++ ) {
        var index = this.data_students_osa.findIndex(x => x.cour_ID == arrCOURs[i].cour_ID);
        if (index > -1) {
            arrTEMP.push(this.data_students_osa[x])
            arrReturn.push(this.data_students_osa[x])
            arrReturn[compCODE] = ''
        }   
        
    }
} // END STUDENT LOOP

    // var self = this;
    // this.studs.forEach(function(item){   
    //     if (item.cour_ID == self.comp.cour_ID && item.sessann == sessann) 
    //     {arrReturn.push(item);}
    // });
    return arrReturn
},


get_osa:function() {

if (this.prog_sysec == '') 
{alert('Select Program') ; return }

    this.data_students_show = []
    this.data_students_page = []
    this.data_students_osa = []
    this.transmission_type = 'OSA'

// 

// **** **** NEED TO GET BY DATE !!!!
var studSQL = `SELECT  MyMEQ_STUDENT.student_ID,MyMEQ_STUDENT.student_ID AS studID,student_NumAdmission,student_CodePerm, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.prog_ID, MyMEQ_STUDENT.student_PhotoPath, MyMEQ_COURSESTUDENT.cs_MARK, MyMEQ_COURSESTUDENT.cs_REMARK, MyMEQ_COUR.cour_ID, group_SESS + group_ANN AS sessann
,0 AS isSelected, MyMEQ_PROGRAM.prog_CODE, '' AS comp_CODE FROM MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID INNER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID INNER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID 
 WHERE 
group_datEND < '2040-01-01' AND (MyMEQ_STUDENT.prog_ID = ` + this.prog_sysec + `)  and ( cs_MARK > 59 OR cs_REMARK = 'EQ')`




// var studSQL = `SELECT  MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.prog_ID, MyMEQ_STUDENT.student_PhotoPath, MyMEQ_COURSESTUDENT.cs_MARK, MyMEQ_COURSESTUDENT.cs_REMARK, MyMEQ_COUR.cour_ID, group_SESS + group_ANN AS sessann FROM     MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID INNER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID WHERE `
// for ( var looper = 0; looper < this.data_students_unique.length ; looper++ ) {
//     studSQL += " ((MyMEQ_STUDENT.student_ID = " + this.data_students_unique[looper].student_ID + ")  AND (cs_MARK > 59 OR cs_REMARK = 'EQ')) OR "
// }
// studSQL = studSQL.slice(0, studSQL.length -3);


console.log(studSQL)




    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(studSQL))
    .then(res => { 
        // this.data_students_osa = res.data

for ( var looper = 0; looper < res.data.length ; looper++ ) {
    if (res.data[looper].prog_ID == this.prog_sysec) {this.data_students_osa.push(res.data[looper])}
}
this.data_students_osa = this.data_students_osa.sort((a, b) => a.student_lNAME.localeCompare(b.student_lNAME))

    });

},


get_osa_XX:function() {

this.clear_data();
var query = '';
this.data_view = ""

// GET ALL STUDENTS -- NEED A WAY TO GET ALL COURSES FOR STUDENTS IN THIS SESS ! ????
query = `SELECT DISTINCT MyMEQ_STUDENT.student_ID FROM MyMEQ_GROUP INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_GROUP.group_ID = MyMEQ_COURSESTUDENT.group_ID INNER JOIN MyMEQ_STUDENT ON MyMEQ_COURSESTUDENT.student_ID = MyMEQ_STUDENT.student_ID 
INNER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID  
 WHERE (MyMEQ_STUDENT.prog_ID = ` + this.prog_sysec + `) AND (MyMEQ_GROUP.group_SESS = '` + this.grp_sess + `') AND  (MyMEQ_GROUP.group_ANN = '` + this.grp_ann + `')`


axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
this.data_students_unique = res.data

var studSQL = `SELECT  MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_PhotoPath, MyMEQ_COURSESTUDENT.cs_MARK, MyMEQ_COURSESTUDENT.cs_REMARK, MyMEQ_COUR.cour_ID FROM     MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID INNER JOIN MyMEQ_GROUP ON MyMEQ_COURSESTUDENT.group_ID = MyMEQ_GROUP.group_ID INNER JOIN MyMEQ_COUR ON MyMEQ_GROUP.cour_ID = MyMEQ_COUR.cour_ID WHERE `
for ( var looper = 0; looper < res.data.length; looper++ ) {
    studSQL += " (MyMEQ_STUDENT.student_ID = " + res.data[looper].student_ID + ") OR " //  + " AND cs_MARK > 59) OR"
}
studSQL = studSQL.slice(0, studSQL.length -3);

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(studSQL))
.then(res => { 
this.data_students_osa = res.data


this.data_view = "OSA"


this.filter_osa_student(this.data_comps_unique[0].comp_ID)

// GET COMPETENCES FOR PROGRAM 
/*
query = `SELECT DISTINCT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.prog_ID, MyMEQ_STUDENT.student_lNAME, MyMEQ_STUDENT.student_fNAME, MyMEQ_STUDENT.student_GRPCODE, student_PhotoPath FROM MyMEQ_GROUP INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_GROUP.group_ID = MyMEQ_COURSESTUDENT.group_ID INNER JOIN MyMEQ_STUDENT ON MyMEQ_COURSESTUDENT.student_ID = MyMEQ_STUDENT.student_ID 
INNER JOIN MyMEQ_PROGRAM ON MyMEQ_STUDENT.prog_ID = MyMEQ_PROGRAM.prog_ID  
 WHERE (MyMEQ_STUDENT.prog_ID = ` + this.prog_sysec + `) AND (MyMEQ_GROUP.group_SESS = '` + this.grp_sess + `') AND  (MyMEQ_GROUP.group_ANN = '` + this.grp_ann + `')  ORDER BY  MyMEQ_STUDENT.student_lNAME`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
this.data_students_osa = res.data */


}) // END AXIOS
}) // END AXIOS 

},

osa_process:function(item, i, callback) {

var comps =  this.data_comps.filter(function (el) {
    el.comp_ID == this.data_comps_unique[i].comp_ID
}) // END FILTER 

var compSQL = ''
for ( var looper = 0; looper < comps.length; looper++ ) {
    compSQL += "(cour_ID = " + comps[looper].cour_ID  + " AND cs_MARK > 59) OR"
}
compSQL = compSQL.slice(0, compSQL.length -3);

var osaSQL = ''
for ( var looper = 0; looper < this.data_students_osa.length; looper++ ) {
    osaSQL += "(student_ID = " +  + ") AND "
}


},
osa_process_complete:function() {

},




//(this.data_pond_notes,this.save_string_append, this.save_note_end)
doSynchronousLoop:function(data, processData, done) {
    if (data.length > 0) {
        var loop = function(data, i, processData, done) {
            processData(data[i], i, function() {
                if (++i < data.length) {  setTimeout(function(){ loop(data, i, processData, done);  }, 0);
                } else {    done();    }  });  };
        loop(data, 0, processData, done); } else { done(); }
},


// =================================================================================================


read_file_image:function(event) {

this.isLoading=true


      var reader = new FileReader();
      reader.onloadend = (e) => {
        this.data_xml = e.target.result;

        // console.log('**** IMG START ****')
         console.log(this.data_xml)
        // console.log('**** IMG ENDER ****')
  
        this.convert_xml_json().then()
        this.isLoading=false
      }
      reader.readAsText('src/assets/Files/Tran/dSRTDE22.XML', 'ISO-8859-1'); 
  
},

async convert_xml_json() {

var self = this // assign context to self variable
xml2js.parseString(this.data_xml, {explicitArray : false}, function (err, result) {
    const json = result

    console.log(json)

}) // END INNER XML FUNCTION

}, // END FUNCTION




// ----------------------- FTP
check_files_ftp:function() {
this.isLoading=true

var ecole = sessionStorage.getItem('college_nickname')
axios.get(this.$url+'/ftp_get_list?ecole='+ecole)
.then(res => {
    var fileFTP = res.data

// console.log(res.data)



// ---- SOCRATES ....
for (var iFILE = 0; iFILE < this.data_files_pending.length; iFILE++) {
    var flC = 'SRTCO'+this.data_files_pending[iFILE].fileTran_FILE
    var flD = 'SRTDE'+this.data_files_pending[iFILE].fileTran_FILE

    for (var iFTP = 0; iFTP < fileFTP.length; iFTP++) { 
        if (fileFTP[iFTP].name.replace(/\.[^/.]+$/, "") == flC)
        {this.data_files_pending[iFILE].fileConfirm = true
        this.data_files_pending[iFILE].fileFTP_CON = fileFTP[iFTP].name}

        if (fileFTP[iFTP].name.replace(/\.[^/.]+$/, "") == flD)
        {this.data_files_pending[iFILE].fileDetail = true
        this.data_files_pending[iFILE].fileFTP_DET = fileFTP[iFTP].name}
    } // END FTP FOR
} // END FILE FOR
// ---- SYSEC ....
for (iFILE = 0; iFILE < this.data_files_pending.length; iFILE++) {
    flC = 'SECCO'+this.data_files_pending[iFILE].fileTran_FILE
    flD = 'SECDE'+this.data_files_pending[iFILE].fileTran_FILE

    for (iFTP = 0; iFTP < fileFTP.length; iFTP++) { 
        if (fileFTP[iFTP].name.replace(/\.[^/.]+$/, "") == flC)
        {this.data_files_pending[iFILE].fileConfirm = true
        this.data_files_pending[iFILE].fileFTP_CON = fileFTP[iFTP].name}

        if (fileFTP[iFTP].name.replace(/\.[^/.]+$/, "") == flD)
        {this.data_files_pending[iFILE].fileDetail = true
        this.data_files_pending[iFILE].fileFTP_DET = fileFTP[iFTP].name}
    } // END FTP FOR
} // END FILE FOR





    this.isLoading=false
});
 

},


print_errors:function() {
    // PRINT THE ERRORS
    alert('print')
},




test_encrypt:function() {

axios.get(this.$url+'/file_decrypt')
.then(res => {
    alert(res.data)
});

},

chk_string:function(val){
    // CHECK FOR BLANC STRING --
    try {return val.replace(/'/g,"''")}
    catch(err) {return ''}
},

randomKey:function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
},

sortNav() {
    if (this.navOpen) {this.closeNav()} else {this.openNav()}
},
openNav() {
  document.getElementById("mySidebar").style.width = "300px";
  document.getElementById("mainContent").style.marginLeft = "300px";
  this.navOpen = true;
  this.new_show= false;
},
/* Set the width of the sidebar to 0 and the left margin of the page content to 0 */
closeNav() {  
  document.getElementById("mySidebar").style.width = "0";
  document.getElementById("mainContent").style.marginLeft = "0";
  this.navOpen = false;
},

}, // END METHODS


}
</script>

<style scoped>


</style>